import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
// import { PickupLocationsDialogComponent } from 'src/@order/dialogs/pickup-locations-dialog/pickup-locations-dialog.component';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { DataService } from 'src/@order/services/data.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import {
  PACKAGESIZETYPE,
  cashSerive,
  deliveryMethods,
  handlingMethods,
  paymentMethods,
  standardPackageSizes,
} from 'src/@order/commonData/commonUiData';
import { animate, style, transition, trigger } from '@angular/animations';
import { OrderPool } from 'src/app/utils/systemEnums';
import { standardOrderModel } from 'src/@order/commonData/standardOrderInitialize.model';
import { PromoCodesDialogComponent } from 'src/@order/dialogs/promo-codes-dialog/promo-codes-dialog.component';
import { formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { InfoDialogComponent } from 'src/@order/dialogs/info-dialog/info-dialog.component';
import { NoDriverAvailableDialogComponent } from 'src/@order/dialogs/no-driver-available-dialog/no-driver-available-dialog.component';
import { AddNewLocationDialogComponent } from 'src/@order/dialogs/add-new-location-dialog/add-new-location-dialog.component';
import { appMessages } from 'src/@order/commonData/app-messages';
import { ComponentCanDeactivate } from 'src/app/core/auth/guards/pending-changes.guard';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AutoSuggestPromoComponent } from 'src/@order/dialogs/auto-suggest-promo/auto-suggest-promo.component';
import { ProgressBarService } from 'src/@order/components/progress-bar/progress-bar.service';
import { ConfirmationDialogComponent } from 'src/@order/dialogs/confirmation-dialog/confirmation-dialog.component';
import { FacebookApiService } from 'src/@order/services/FacebookApi.service';
import { SaverDeliveryMethodInfoComponent } from 'src/@order/components/bottom-sheets/saver-delivery-method-info/saver-delivery-method-info.component';
import * as DeviceDetector from 'device-detector-js';
import { MatDrawer } from '@angular/material/sidenav';
import { debounceTime, filter } from 'rxjs/operators';

interface DeviceInfo {
  webAppModelName: string;
  brand: string;
  type: string;
  os: string;
}

export class EnhancedDeviceDetector {
  private deviceDetector = new (DeviceDetector as any)();

  getDeviceInfo(): DeviceInfo {
    const device = this.deviceDetector.parse(navigator.userAgent);
    // Get basic info
    const deviceType = device.device?.type || 'desktop';
    const osName = device.os?.name || 'Unknown';
    // Enhanced model detection
    const webAppModelName = this.detectModel(device, navigator.userAgent);
    const brand = this.detectBrand(device, navigator.userAgent);

    return {
      webAppModelName,
      brand,
      type: deviceType,
      os: osName,
    };
  }

  private detectModel(device: any, userAgent: string): string {
    // Check if mobile/tablet first
    if (device.device?.model) {
      return device.device.model;
    }
    // Desktop/laptop detection
    if (device.device?.type === 'desktop' || !device.device?.type) {
      return this.detectDesktopModel(userAgent);
    }
    return device.device?.type || 'Unknown';
  }

  private detectBrand(device: any, userAgent: string): string {
    if (device.device?.brand) {
      return device.device.brand;
    }
    // Detect based on OS and user agent
    const osName = device.os?.name?.toLowerCase() || '';
    if (osName.includes('mac') || userAgent.includes('Macintosh')) {
      return 'Apple';
    }
    if (osName.includes('windows')) {
      return this.detectWindowsBrand(userAgent);
    }
    return 'Unknown';
  }

  private detectDesktopModel(userAgent: string): string {
    // Mac detection
    if (userAgent.includes('Macintosh')) {
      if (userAgent.includes('MacBook')) {
        return 'MacBook';
      } else if (userAgent.includes('iMac')) {
        return 'iMac';
      } else if (userAgent.includes('Mac Pro')) {
        return 'Mac Pro';
      }
      return 'Mac';
    }
    // Windows - unfortunately, specific manufacturer info is rarely available
    if (userAgent.includes('Windows')) {
      // Some edge cases where manufacturer might be detectable
      if (userAgent.includes('Dell')) return 'Dell';
      if (userAgent.includes('HP')) return 'HP';
      if (userAgent.includes('Lenovo')) return 'Lenovo';
      if (userAgent.includes('ASUS')) return 'ASUS';
      if (userAgent.includes('Acer')) return 'Acer';
      return 'Windows PC';
    }
    return 'Desktop';
  }

  private detectWindowsBrand(userAgent: string): string {
    // Limited detection possible from user agent
    const brands = ['Dell', 'HP', 'Lenovo', 'ASUS', 'Acer', 'MSI', 'Samsung'];
    for (const brand of brands) {
      if (userAgent.includes(brand)) {
        return brand;
      }
    }
    return 'Windows PC';
  }
}

@Component({
  selector: 'app-standard-order',
  templateUrl: './standard-order.component.html',
  styleUrls: ['./standard-order.component.scss'],
  animations: [
    trigger('showHide', [
      transition(':enter', [
        style({ transform: 'translateY(-20px)', opacity: 0 }),
        animate(200, style({ transform: 'translateY(0px)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate(200, style({ transform: 'translateY(-20px)', opacity: 0 })),
      ]),
    ]),
  ],
})
export class StandardOrderComponent
  implements OnInit, OnDestroy, ComponentCanDeactivate {
  /* to check where to user come (whatsapp or direct) */
  redirectByWA: boolean = false;
  /* for ui text */
  headings = {
    packageDestination: `What's Your package destination?`,
    relocate: `Move or Relocate:`,
    whatToPlan: `What's the Plan?`,
    pickupLocation: `Pickup Location`,
    dropOffLocation: `Dropoff Location`,
  };

  tipText: string = '';

  /* to save user/pdas data */
  customerData;

  /* get important data form local*/
  handlingMethods = JSON.parse(JSON.stringify(handlingMethods));
  deliveryMethods = JSON.parse(JSON.stringify(deliveryMethods));
  paymentMethods = JSON.parse(JSON.stringify(paymentMethods));
  cashSerive = JSON.parse(JSON.stringify(cashSerive));
  packageSizes: PACKAGESIZETYPE[] = JSON.parse(
    JSON.stringify(standardPackageSizes)
  );
  isBusinessPartner: boolean = false;

  /* general variable */
  selectedCountryCode;
  handlingData = [];
  handlingItem;
  currentTime = new Date();
  groupIndex;
  handlingAllData;
  selectedDeliveryMethod;
  selectedPaymentMethod;
  isPromoSuggested: boolean = false;
  promoCodeList: [] = [];
  appliedPromo;
  form!: FormGroup;
  docIdFire;
  private unsubscribe$ = new Subject<void>();
  orderDoc: any = null;
  confirmOrderRes: any;
  filteredDeliveryMethods: any = [];
  selectedHandling;
  selectedPackageSize: any;

  /* general flags */
  isConfirmingOrder: boolean = false;
  isAttachmentUploaded: boolean = false;
  attachmentUploadedUrl: string;
  isDataLoading: boolean = false;
  isHeavyItemAndRelocateOrder: boolean = false;
  isOrderConfirmed: boolean = false;
  selectedCashService;

  isSeverPlan: boolean = false;
  dropPointsToShow: any[] = [];
  isDeliveryChargeLoading: boolean = false;

  /* FOR CERRY ORDER DATA FROM LOCALST. */
  pendingOrderData;
  hardReload: boolean = false;

  isSaverPlanBottomSheetShow: boolean = false;
  isPharmacyOrder: boolean = false;

  private isRestoringFromLocal = false;
  private lastSelectedToSnapshot: string | null = null;

  activeDropoffIndex: number = 0; // Track which dropoff is currently active

  // Add Firebase update optimization properties
  private pendingFirebaseUpdates: any = {};
  private firebaseUpdateTimeout: any = null;
  private readonly FIREBASE_DEBOUNCE_DELAY = 1000; // 1 second debounce

  // Computed properties for better performance and cleaner template
  get shouldShowPaymentSummary(): boolean {
    return this.anyDropOffSelected() && this.selectedDeliveryMethod?.dropPoint;
  }

  get shouldShowDeliveryMethods(): boolean {
    const hasFilteredMethods = this.filteredDeliveryMethods.length > 0;
    const hasFirebaseCharges =
      this.orderDoc?.deliveryCharges &&
      this.orderDoc.deliveryCharges.length > 0;
    const isLoading = this.isDeliveryChargeLoading;
    const hasDropoffLocation = this.anyDropOffSelected();

    return hasDropoffLocation && (hasFilteredMethods || hasFirebaseCharges);
  }

  get shouldShowHandlingSection(): boolean {
    // Show handling section by default - don't wait for drop-off location
    return true;
  }

  get hasDefaultHandlingSelected(): boolean {
    return this.handlingMethods.some((method) => method.isSelected);
  }

  /* detect before page reload */
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    // returning false will show a confirm dialog before navigating away
    if (localStorage.getItem('PWAToken')) {
      if (
        this.form?.get('pickupLocationAddress')?.value &&
        !this.isConfirmingOrder &&
        !this.hardReload
      ) {
        // this.saveDataInfoLocal();
        return false;
      } else {
        this.unsubscribeFromDocument();
        return true;
      }
    } else {
      return true;
    }
  }

  deviceInfo: DeviceInfo;

  @ViewChild('pickupDrawer') pickupDrawer: MatDrawer;

  drawerContext: { type: 'pickup' | 'dropoff'; dropoffIndex?: number } = {
    type: 'pickup',
  };

  isPickupDrawerOpen = false;

  constructor(
    private _fb: FormBuilder,
    private _matDialog: MatDialog,
    private _dataService: DataService,
    private _matSnackBar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
    private _auth: AuthServiceLocal,
    private _FacebookApiService: FacebookApiService,
    private renderer: Renderer2,
    private _progressBar: ProgressBarService,
    private _router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private afs: AngularFirestore
  ) {
    /* check where to user come */
    if (localStorage.getItem('redirectByWA')) {
      this.redirectByWA = true;
    } else {
      this.redirectByWA = false;
    }

    if (localStorage.getItem('isBusinessPartner') == '1') {
      this.isBusinessPartner = true;
    } else {
      this.isBusinessPartner = false;
    }
    /* set country pin code */
    this.selectedCountryCode = localStorage.getItem('phoneCode');

    /* 
      CHECK IS HEAVY ITEM & RELOCATION ITEM OR NOT
    */
  }

  private setTipText(): void {
    const storedCountry = localStorage.getItem('country');
    const phoneCode = localStorage.getItem('phoneCode');
    const country = storedCountry
      ? storedCountry.trim()
      : phoneCode === '+233'
        ? 'Ghana'
        : 'Nigeria';

    if (country === 'Ghana') {
      this.tipText =
        'Tip: To avoid high prices, type the specific location in your area for example a town, city, or popular landmark not just the general area name.';
    } else {
      this.tipText =
        'Tip: To avoid high prices, type the specific location in your area for example a street, neighborhood, or popular landmark not just the broad area name.';
    }
  }

  ngOnInit(): void {
    this._ActivatedRoute.url.pipe(take(1)).subscribe((url) => {
      if (url[0].path == 'standard-heavy') {
        this.isHeavyItemAndRelocateOrder = true;
      } else {
        this.isHeavyItemAndRelocateOrder = false;
      }
    });

    /* creating form here FIRST - before any other operations */
    this.createForm();

    console.log('bruhh ded', this.dropPointsToShow);
    this.setDropPoints();

    // filter handling method accoding to country.
    this.filterHandlingMethodByCountry();

    // filter Delivery method accoding to country.
    this.filterDeliveryMethodByCountry();

    // Initialize delivery methods
    this.initializeFilteredDeliveryMethods();

    // Only add the initial drop row if there is no saved order data
    const hasPendingOrder =
      localStorage.getItem('PENDINGORDERDATA') ||
      localStorage.getItem('PENDINGHEAVYORDERDATA');
    if (!hasPendingOrder) {
      this.addDropRow();
    }

    // Ensure at least one dropoff row exists
    if (this.dropoffLocations.length === 0) {
      this.addDropRow();
    }

    // set country-specific tip text based on logged-in user
    this.setTipText();

    // Note: Firebase document will be initialized when pickup location is selected

    this._ActivatedRoute.queryParams.pipe(take(1)).subscribe((res: any) => {
      // handleWAkey
      if (res?.wa == 1) {
        if (!localStorage.getItem('redirectByWA')) {
          localStorage.setItem('redirectByWA', '1');
        }
      }
    });

    /* MAIN FUNCTION TO START ORDER FLOW */
    this.getAPIdataAndStartOrder();

    // OPTIMIZATION: Debounced form value changes to reduce Firebase writes
    this.form.valueChanges
      .pipe(
        debounceTime(2000), // Increased debounce time to reduce writes
        filter((res) => {
          // Only save if we have meaningful data and not during order confirmation
          return !!(
            (
              this.form?.get('pickupLocationAddress')?.value &&
              !this.isConfirmingOrder &&
              res &&
              this.docIdFire
            ) // Only save if Firebase is initialized
          );
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((res) => {
        this.saveDataInfoLocal();
      });

    console.log(
      'this.dropoffLocations?.controls',
      this.dropoffLocations?.controls
    );
  }

  setDropPoints() {
    console.log('bruhh ded', this.orderDoc?.deliveryCharges);
    console.log('bruhh ded', this.selectedDeliveryMethod);
    if (this.orderDoc?.deliveryCharges?.length) {
      if (this.selectedDeliveryMethod?.id) {
        // find by type
        const matchedCharge = this.orderDoc.deliveryCharges.find(
          (c: any) => c.id === this.selectedDeliveryMethod.id
        );
        this.dropPointsToShow = matchedCharge?.dropPoint || [];
      } else {
        // fallback to first element's dropPoint
        this.dropPointsToShow =
          this.orderDoc.deliveryCharges[0]?.dropPoint || [];
      }
    } else {
      this.dropPointsToShow = [];
    }
  }

  getAPIdataAndStartOrder() {
    /* FIRST GET ALL IMPORTANT APIS DATA THEN PROCEED TO FATHER FLOW */
    Promise.all([
      this._progressBar.show(),
      this.getOrderHandlingType(),
      this.getAllPromoCode(),
    ]).then(() => {
      /* for check case ([new order] case  or [unsuccessful order which is saved in our localstorage] case) */
      this.getQueryParams();
      this.locationsFireHandling();
      this._progressBar.hide();
    });
  }

  locationsFireHandling() {
    // Firebase document will be initialized when pickup location is selected
    // set pickup location info form field
    this._dataService.selectedLocation
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        console.log('Pickup location selected:', result);
        this.form?.get('pickupLocation')?.setValue(result);
        this.form?.get('pickupLocationAddress')?.setValue(result.address);

        // Update Firebase if document is already initialized
        if (this.docIdFire) {
          console.log(
            'Firebase already initialized, updating pickup address immediately'
          );
          const params = {
            'selectedAddress.from': [result],
            changeStatus: 1,
          };
          this.updateDocWithParams(params);
        } else {
          console.log(
            'Firebase not initialized yet, pickup address will be updated when Firebase gets initialized'
          );
        }
      });

    // set dropoff location's info form field.
    this._dataService.dropoffLocation
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        console.log('result', result);

        // UPDATE IN FORM
        this.dropoffLocations.controls[this.groupIndex]
          ?.get('dropoffPointAddress')
          .setValue(result.address);
        this.dropoffLocations.controls[this.groupIndex]
          ?.get('dropoffPoint')
          .setValue(result);

        // update on firebase
        if (this.isHeavyItemAndRelocateOrder) {
          if (this.form.get('globalPackageSize').value) {
            this.dropoffLocations.controls[this.groupIndex]
              ?.get('dropoffPoint')
              .setValue({
                ...this.dropoffLocations.controls[this.groupIndex]?.get(
                  'dropoffPoint'
                ).value,
                packageSize: String(this.form.get('globalPackageSize').value),
              });
            this.dropoffLocations.controls[this.groupIndex]
              ?.get('packageSize')
              .setValue(String(this.form.get('globalPackageSize').value));
            this.updateDropOff();
          } else {
            this.updateDropOff();
          }
        } else {
          this.updateDropOff();
        }
      });

    // remove tip if applied.
    this.form.get('useTip').valueChanges.subscribe((res) => {
      if (!res) {
        this.form.get('tipAmount').setValue('');
        this.form.get('tipAmount').setValidators(null);
        this.form.get('tipAmount').updateValueAndValidity();
        const params = {
          isTipGiven: 0,
          tipAmount: 0,
          tipId: 0,
          changeStatus: 1,
        };
        this.updateDocWithParams(params);
      } else {
        this.form.get('tipAmount').setValidators(Validators.required);
        this.form.get('tipAmount').updateValueAndValidity();
      }
    });

    this.form.get('isLoadingFeeApplied').valueChanges.subscribe((res) => {
      if (res) {
        this._matSnackBar.open(appMessages.loadingFeeInfo, 'OKAY', {
          duration: 5000,
        });
        const params = {
          isLoadingFeeApplied: 1,
          changeStatus: 1,
        };
        this.updateDocWithParams(params);
      } else {
        const params = {
          isLoadingFeeApplied: 0,
          changeStatus: 1,
        };
        this.updateDocWithParams(params);
      }
    });

    /* 
      Schedule Delivery
    */
    // check is schedule Delivery update on firebase.
    this.form.get('scheduleDelivery').valueChanges.subscribe((res) => {
      if (res && this.form.get('isScheduleDelivery').value) {
        // update on firebase.
        const params = {
          isSchedule: 1,
          scheduleDate: res.toString(),
          time: this._dataService.dateFormate(res),
          changeStatus: 1,
        };
        console.log('params update on firebase', params);

        this.updateDocWithParams(params);
      }
    });
    // uncheck schedule delivery
    this.form.get('isScheduleDelivery').valueChanges.subscribe((res) => {
      if (!res) {
        const params = {
          isSchedule: 0,
          scheduleDate: '',
          time: this._dataService.dateFormate(this.currentTime),
          changeStatus: 1,
        };

        if (this.form.get('scheduleDelivery').value)
          this.form.get('scheduleDelivery').setValue('');

        this.updateDocWithParams(params);
      } else {
        if (!this.form.get('scheduleDelivery').value)
          this.form
            .get('scheduleDelivery')
            .setValue(new Date(this.currentTime));
      }
    });
  }

  subscribeDoc() {
    // Check if docIdFire is available before subscribing
    if (!this.docIdFire) {
      console.warn(
        'Cannot subscribe to Firebase document: docIdFire is not set'
      );
      return;
    }

    console.log('Subscribing to Firebase document:', this.docIdFire);

    // get DeliveryCharges changes.
    this.updateOrderDoc()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((updatedDoc: any) => {
        if (updatedDoc) {
          console.log('updatedDoc', updatedDoc);

          this.orderDoc = updatedDoc;

          if (updatedDoc?.isPharmacyOrder == 1) {
            this.isPharmacyOrder = true;
            if (
              updatedDoc.paymentMethod?.length &&
              updatedDoc?.deliveryCharges?.length
            ) {
              this.paymentMethods = this.paymentMethods.filter((item) =>
                updatedDoc?.paymentMethod.find(
                  (ele) => ele == 4 && item.id == 3
                )
              );
            }
          } else {
            this.isPharmacyOrder = false;
          }

          if (updatedDoc.isSaverPlanOn == 1) this.isSeverPlan = true;
          else this.isSeverPlan = false;

          // FIX: Always initialize filteredDeliveryMethods, even if no deliveryCharges
          if (!this.filteredDeliveryMethods.length) {
            this.filteredDeliveryMethods = [...this.deliveryMethods];
          }

          // If we have handling item selected but no delivery charges yet, show loading
          if (this.handlingItem && !updatedDoc?.deliveryCharges?.length) {
            this.isDeliveryChargeLoading = true;
          }

          // update deliveryMethods values
          if (updatedDoc?.deliveryCharges?.length) {
            console.log(
              'Delivery charges received from Firebase:',
              updatedDoc?.deliveryCharges
            );
            console.log(
              'Number of delivery charges:',
              updatedDoc?.deliveryCharges?.length
            );

            // Store the currently selected delivery method ID before updating the array
            const selectedMethodId = this.selectedDeliveryMethod?.id || null;

            this.filteredDeliveryMethods = this.mergeArrays(
              this.deliveryMethods,
              updatedDoc?.deliveryCharges
            ).sort((a, b) => a.id - b.id);

            // After updating filteredDeliveryMethods, restore the selection state
            if (selectedMethodId) {
              this.filteredDeliveryMethods.forEach((item) => {
                if (item.id === selectedMethodId) {
                  item.isSelected = 1;
                  this.selectedDeliveryMethod = item;
                } else {
                  item.isSelected = 0;
                }
              });

              // Update dropPointsToShow when selectedDeliveryMethod is updated
              if (this.selectedDeliveryMethod?.dropPoint) {
                this.dropPointsToShow = this.selectedDeliveryMethod.dropPoint;
              } else {
                this.dropPointsToShow = [];
              }
            }

            if (this.isSeverPlan) {
              let subIdItemFire = updatedDoc?.deliveryCharges.filter(
                (item) => item.subId == 2
              )[0];

              if (subIdItemFire) {
                const subIdItemLocal = deliveryMethods.filter(
                  (item) => item.id == 7
                )[0];

                if (subIdItemLocal) {
                  subIdItemFire['id'] = subIdItemLocal?.id;
                  subIdItemFire['title'] = subIdItemLocal?.title;
                  subIdItemFire['label'] = subIdItemLocal?.label;
                  subIdItemFire['icon'] = subIdItemLocal?.icon;
                  subIdItemFire['isSelected'] = subIdItemLocal?.isSelected;
                  subIdItemFire['notSelectable'] =
                    subIdItemLocal?.notSelectable;
                  console.log('margeObj', subIdItemFire);
                }
                if (localStorage.getItem('country') == 'Nigeria') {
                  this.filteredDeliveryMethods.splice(1, 0, subIdItemFire);
                } else {
                  this.filteredDeliveryMethods.splice(2, 0, subIdItemFire);
                }
              }

              if (this.isSeverPlan) {
                const temp = JSON.parse(
                  JSON.stringify(this.filteredDeliveryMethods)
                );
                console.log('temp', temp);
                const rearrangedArr = [
                  // temp.slice(0, 1)[0], // {id: 1}
                  // temp.slice(1, 2)[0],  // {id: 2}
                  // temp.slice(2, 3)[0], // {id: 3}
                ];
              }
            }

            const pendingOrderData = localStorage.getItem('PENDINGORDERDATA');
            let parsedPendingData = null;
            if (pendingOrderData) {
              try {
                parsedPendingData = JSON.parse(pendingOrderData);
              } catch (error) {
                console.error('Error parsing PENDINGORDERDATA:', error);
                localStorage.removeItem('PENDINGORDERDATA');
              }
            }

            // Handle special case for saver plan (id == 7)
            if (parsedPendingData?.selectedDeliveryMethod?.id == 7) {
              this.filteredDeliveryMethods.forEach((item) =>
                item.id == parsedPendingData?.selectedDeliveryMethod?.id
                  ? (item.isSelected = 1)
                  : null
              );
            }

            this.isDataLoading = false;
            this.isDeliveryChargeLoading = false;
            console.log(
              'Delivery charge loading completed. Filtered methods:',
              this.filteredDeliveryMethods.length
            );
            this.setDropPoints();
          }

          if (updatedDoc && updatedDoc['changeStatus'] == 0) {
            this.isDataLoading = false;
            this.isDeliveryChargeLoading = false;
          }

          // selected loader default
          if (
            updatedDoc?.isLoadingFeeApplied == 1 &&
            !this.form.get('isLoadingFeeApplied').value
          )
            this.form.get('isLoadingFeeApplied').setValue(1);
        }
      });
  }

  openBottomSheet() {
    this.isPromoSuggested = true;
    if (
      this.promoCodeList?.length &&
      !this.isPharmacyOrder &&
      !this.isSeverPlan
    )
      this._bottomSheet
        .open(AutoSuggestPromoComponent, {
          panelClass: ['bottomSheetWrapper'],
          disableClose: true,
          data: {
            title: 'Use Promo',
            promoList: this.promoCodeList.length ? this.promoCodeList : [],
          },
        })
        .afterDismissed()
        .subscribe((res) => {
          if (res) {
            this.appliedPromo = res;
            this.form.get('isPromoApplied').setValue(true);
            this.form.get('promoTitle').setValue(res.promoTitle);
            const params = {
              isPromoCodeApplied: 1,
              promoTitle: res.promoTitle,
              changeStatus: 1,
              promoStatus: 0,
            };
            this.updateDocWithParams(params);
          } else {
            this.form.get('isPromoApplied').setValue(false);
            this.form.get('promoTitle').setValue('');
            this.removePromoCode();
          }
        });
  }

  mergeArrays(firstArray, secondArray) {
    const thirdArray = [];
    if (this.isSeverPlan) {
      console.log('merge if else');
      console.log('secondArray', secondArray);
      console.log('firstArray', firstArray);
      secondArray.forEach((obj2) => {
        if (obj2?.subId != 2) {
          const matchedObj = firstArray.find((obj1) => obj1.id === obj2.id);
          if (matchedObj) {
            const mergedObj = { ...matchedObj, ...obj2 };
            console.log('mergedObj', mergedObj);
            console.log(this.selectedDeliveryMethod);
            console.log(this.dropoffLocations);
            thirdArray.push(mergedObj);
          }
        }
      });
    } else {
      console.log('merge else');

      secondArray.forEach((obj2) => {
        const matchedObj = firstArray.find((obj1) => obj1.id === obj2.id);
        if (matchedObj) {
          const mergedObj = { ...matchedObj, ...obj2 };
          thirdArray.push(mergedObj);
        }
      });
    }
    return thirdArray;
  }

  anyDropOffSelected() {
    return (
      this.dropoffLocations?.value?.some(
        (val) => val?.dropoffPointAddress !== ''
      ) || false
    );
  }

  filterHandlingMethodByCountry() {
    if (this.isHeavyItemAndRelocateOrder) {
      this.handlingMethods = this.handlingMethods.filter(
        (methods) => methods.id == 3 || methods.id == 4
      );
    } else {
      if (localStorage.getItem('country') == 'Nigeria') {
        this.handlingMethods = this.handlingMethods.filter(
          (methods) => methods.id == 1 || methods.id == 2
        );
      } else {
        this.handlingMethods = this.handlingMethods.filter(
          (methods) => methods.id == 1 || methods.id == 2
        );
      }
    }

    // Set default handling selection after filtering
    this.setDefaultHandlingSelection();
  }

  filterDeliveryMethodByCountry() {
    if (this.isHeavyItemAndRelocateOrder) {
      if (localStorage.getItem('country') == 'Nigeria') {
        this.deliveryMethods = this.deliveryMethods.filter(
          (method) =>
            method.id === 3 ||
            method.id === 4 ||
            method.id === 5 ||
            method.id === 6
        );
        console.log('this.deliveryMethods', this.deliveryMethods);
      } else {
        this.deliveryMethods = this.deliveryMethods.filter(
          (method) => method.id === 6 || method.id === 3 || method.id === 5
        );
      }
    } else {
      if (localStorage.getItem('country') == 'Nigeria') {
        this.deliveryMethods = this.deliveryMethods.filter(
          (method) => method.id === 2 || method.id === 3 || method.id === 4
        );
      } else {
        this.deliveryMethods = this.deliveryMethods.filter(
          (method) => method.id === 1 || method.id === 2 || method.id === 3
        );
      }
    }
  }

  initializeOrder() {
    try {
      const authUser = localStorage.getItem('authUser');
      if (!authUser) {
        console.error('No authUser found in localStorage');
        return;
      }
      this.customerData = JSON.parse(authUser);
      console.log('customerData===>', this.customerData);

      if (!this.customerData) {
        console.error('No customer data found in localStorage');
        return;
      }

      const time = new Date();
      standardOrderModel['PDAS_Id'] = this.customerData.PDAS_Id;
      standardOrderModel['userId'] = this.customerData.id;
      const docId = `${standardOrderModel['userId']}_${time.getTime()}`;
      standardOrderModel['uniqueId'] = docId;
      (standardOrderModel['time'] = time.toISOString()),
        (standardOrderModel['region'] = localStorage.getItem('country'));
      standardOrderModel['createdAt'] = time;
      standardOrderModel['calculateWithCar'] = 1;
      standardOrderModel['isHeavyRelocationOrder'] = this
        .isHeavyItemAndRelocateOrder
        ? 1
        : 0;
      standardOrderModel['calculateWithTruck'] =
        localStorage.getItem('country') == 'Ghana' ? 1 : 1;

      // Use EnhancedDeviceDetector to get device info
      const enhancedDeviceDetector = new EnhancedDeviceDetector();
      this.deviceInfo = enhancedDeviceDetector.getDeviceInfo();
      standardOrderModel['webAppModelName'] = this.deviceInfo.webAppModelName;

      console.log('Creating Firebase document with docId:', docId);
      this.afs
        .collection(OrderPool)
        .doc(docId)
        .set(standardOrderModel)
        .then(() => {
          console.log('Firebase document created successfully');
          this.docIdFire = docId;

          // OPTIMIZATION: Only subscribe after document is created
          this.subscribeDoc();
        })
        .catch((error) => {
          console.error('Error creating Firebase document:', error);
          // OPTIMIZATION: Retry logic for failed document creation
          this.retryFirebaseInitialization();
        });
    } catch (error) {
      console.error('Error in initializeOrder:', error);
    }
  }

  // OPTIMIZATION: Retry logic for Firebase initialization
  private retryFirebaseInitialization(retryCount = 0): void {
    const maxRetries = 3;
    if (retryCount < maxRetries) {
      console.log(
        `Retrying Firebase initialization (attempt ${retryCount + 1
        }/${maxRetries})`
      );
      setTimeout(() => {
        this.initializeOrder();
      }, 1000 * (retryCount + 1)); // Exponential backoff
    } else {
      console.error('Failed to initialize Firebase after maximum retries');
      // Fallback: show error to user
      this._matSnackBar.open(
        'Unable to initialize order. Please try again.',
        'OKAY',
        {
          duration: 5000,
        }
      );
    }
  }

  getAllPromoCode() {
    return new Promise((resolve, reject) => {
      this._auth
        .getPromoCodeList({
          minimiumOrderValue: 0,
          orderType: this.isHeavyItemAndRelocateOrder ? 4 : 1,
        })
        .subscribe((res: any) => {
          if (res.response) {
            this.promoCodeList = res.data.promoCodeList;
            resolve(true);
          } else {
            resolve(true);
            // this._matSnackBar.open(res.message, 'Okay', { duration: 3000 });
            this.promoCodeList = [];
          }
        });
    });
  }

  getOrderHandlingType() {
    return new Promise((resovle, reject) => {
      this._auth.getOrderHandlingType().subscribe((res: any) => {
        if (res.response == 200) {
          this.handlingAllData = res.data;
          resovle(true);
        } else {
          this._matSnackBar.open(res.message, 'Okay', { duration: 3000 });
          reject;
        }
      });
    });
  }

  addNewKey(array) {
    array.forEach((obj) => {
      obj['isSelected'] = 0;
    });
    return array;
  }

  // Set default handling method selection
  setDefaultHandlingSelection() {
    if (!this.hasDefaultHandlingSelected && this.handlingMethods.length > 0) {
      // Select the first available handling method by default
      // this.selectHandlingMethods(0);
    }
  }

  selectHandlingMethods(selectedIndex) {
    // Only validate drop-off location if user is actively selecting (not from default selection)
    const isUserSelection =
      this.form?.get('pickupLocationAddress')?.dirty ||
      this.form?.get('pickupLocationAddress')?.touched;

    if (
      isUserSelection &&
      !this.dropoffLocations?.controls?.[
        this.dropoffLocations?.controls?.length - 1
      ]?.get('dropoffPointAddress')?.value
    ) {
      this.showSelectionError('dropoffPointAddress');
      return;
    }

    this.selectLogic(this.handlingMethods, selectedIndex);

    this.selectedHandling = this.handlingMethods.filter(
      (item) => item.isSelected
    )[0];

    // "Packaged"
    if (this.selectedHandling?.id == 1) {
      this.handlingData = this.addNewKey(this.handlingAllData.package);
      this.resetSelectedDeliveryMethod();
      this.handlingItem = null;
    }
    // "care"
    else if (this.selectedHandling?.id == 2) {
      this.handlingData = this.addNewKey(this.handlingAllData.care);
      this.resetSelectedDeliveryMethod();
      this.handlingItem = null;
    }
    // "heavy"
    else if (this.selectedHandling?.id == 3) {
      this.handlingData = this.addNewKey(this.handlingAllData.heavy);
      this.resetSelectedDeliveryMethod();
      this.handlingItem = null;
    }
    // "relocation"
    else if (this.selectedHandling?.id == 4) {
      this.handlingData = this.addNewKey(this.handlingAllData.relocation);
      this.resetSelectedDeliveryMethod();
      this.handlingItem = null;
    }

    // FIX: Initialize filtered delivery methods after handling method selection
    this.initializeFilteredDeliveryMethods();

    // Firebase document should already be initialized when pickup location was selected
    if (this.docIdFire) {
      const params = {
        changeStatus: 1,
        sandingItemKey: this.selectedHandling?.id || 0,
      };
      this.updateDocWithParams(params);
    }

    this.saveDataInfoLocal();
  }

  resetSelectedDeliveryMethod() {
    if (this.selectedDeliveryMethod) {
      this.deliveryMethods.map((item) => (item.isSelected = 0));
      this.selectedDeliveryMethod = null;
      this.dropPointsToShow = [];
    }
    // Don't reset filteredDeliveryMethods here - keep them available for display
  }

  onSelectPackagedItem(selectedIndex) {
    if (!this.handlingItem && !this.isPromoSuggested) {
      setTimeout(() => {
        this.openBottomSheet();
      }, 500);
    }
    this.selectLogic(this.handlingData, selectedIndex);
    this.handlingItem = this.handlingData.filter((item) => item.isSelected)[0];

    if (
      this.form?.get('attachment')?.value ||
      this.form?.get('attachmentInfo')?.value
    )
      this.resetAttachment();

    this.saveDataInfoLocal();

    // FIX: Initialize filteredDeliveryMethods immediately after selecting package item
    // This ensures delivery methods are shown even before Firebase data arrives
    this.initializeFilteredDeliveryMethods();

    // FIX: Include totalCashCollected in the Firebase update
    const params = {
      changeStatus: 1,
      sandingItemKey: this.handlingItem.id,
      sandingItemName: this.form?.get('attachmentInfo')?.value
        ? this.form?.get('attachmentInfo')?.value
        : this.handlingItem.title,
      // FIX: Add totalCashCollected to ensure pricing calculation includes cash collection
      totalCashCollected: this.isTotalCashCollection()
        ? this.getTotalCashCollection()
        : 0,
    };

    console.log('hello in the params of selected package item', params);

    // FIX: Set loading state while waiting for delivery charges calculation
    this.isDataLoading = true;
    this.isDeliveryChargeLoading = true;

    // Firebase document should already be initialized when pickup location was selected
    this.updateDocWithParams(params);
  }

  // FIX: Add new method to initialize filtered delivery methods
  private initializeFilteredDeliveryMethods(): void {
    // Reset any previously selected delivery method
    this.resetSelectedDeliveryMethod();

    // Initialize filteredDeliveryMethods with the base delivery methods
    // This ensures delivery methods are available immediately after package selection
    this.filteredDeliveryMethods = [...this.deliveryMethods];

    console.log(
      'Initialized filteredDeliveryMethods:',
      this.filteredDeliveryMethods.length,
      'methods'
    );

    // If we have orderDoc with delivery charges, merge them
    if (this.orderDoc?.deliveryCharges?.length) {
      this.filteredDeliveryMethods = this.mergeArrays(
        this.deliveryMethods,
        this.orderDoc.deliveryCharges
      ).sort((a, b) => a.id - b.id);

      // Update selectedDeliveryMethod if it was previously selected
      if (this.selectedDeliveryMethod) {
        const updatedSelectedMethod = this.filteredDeliveryMethods.find(
          (item) => item.id === this.selectedDeliveryMethod.id
        );
        if (updatedSelectedMethod) {
          this.selectedDeliveryMethod = updatedSelectedMethod;
          // Update dropPointsToShow when selectedDeliveryMethod is updated
          if (this.selectedDeliveryMethod?.dropPoint) {
            this.dropPointsToShow = this.selectedDeliveryMethod.dropPoint;
          } else {
            this.dropPointsToShow = [];
          }
        }
      }

      // FIX: Stop loading when we have delivery charges
      this.isDataLoading = false;
      this.isDeliveryChargeLoading = false;
    } else {
      // If no delivery charges from Firebase yet, still show the base delivery methods
      // Don't set loading state here - let the individual methods handle loading
      // This allows delivery methods to be visible even without Firebase data
    }
  }

  onSelectPackage(i) {
    // change key based on selected change.
    this.packageSizes.map((item, index) => {
      if (i == index) {
        item.isSelected = 1;
        this.selectedPackageSize = item;
      } else {
        item.isSelected = 0;
      }
    });

    // update in globle form.
    this.form?.get('globalPackageSize')?.setValue(this.selectedPackageSize.id);

    if (this.isHeavyItemAndRelocateOrder) {
      this.dropoffLocations?.controls?.forEach((group) => {
        if (group?.get('dropoffPoint')?.value) {
          group.get('dropoffPoint').value['packageSize'] = String(
            this.selectedPackageSize.id
          );
          group
            ?.get('packageSize')
            ?.setValue(String(this.selectedPackageSize.id));
        }
      });
    }

    // update on firebase.
    this.updateDropOff();

    this.saveDataInfoLocal();
  }

  resetAttachment() {
    this.form?.get('attachmentInfo')?.setValue('');
    this.form?.get('attachment')?.setValue('');
    this.isAttachmentUploaded = false;
    this.attachmentUploadedUrl = '';
  }

  onSelectdeliveryMethods(selectedIndex) {
    if (!this.form?.get('pickupLocationAddress')?.value) {
      this.showSelectionError('pickupLocationAddress');
    } else if (
      !this.dropoffLocations?.controls?.[
        this.dropoffLocations?.controls?.length - 1
      ]?.get('dropoffPointAddress')?.value
    ) {
      this.showSelectionError('dropoffPointAddress');
    } else {
      this.selectLogic(this.filteredDeliveryMethods, selectedIndex);
      this.selectedDeliveryMethod = this.filteredDeliveryMethods.filter(
        (item) => item.isSelected
      )[0];

      // Update dropPointsToShow for payment summary
      if (this.selectedDeliveryMethod?.dropPoint) {
        this.dropPointsToShow = this.selectedDeliveryMethod.dropPoint;
      } else {
        this.dropPointsToShow = [];
      }

      this.saveDataInfoLocal();
      this.updateDropOff();
      console.log('bruhhdeep');
      // NEW: Update delivery charges in each dropoffPoint
      if (
        this.selectedDeliveryMethod &&
        this.selectedDeliveryMethod.dropPoint
      ) {
        this.dropoffLocations?.controls?.forEach((group, idx) => {
          const dropoffPoint = group?.get('dropoffPoint')?.value;
          const matchedDropPoint = this.selectedDeliveryMethod.dropPoint.find(
            (dp) => dp.address === dropoffPoint?.address
          );
          if (matchedDropPoint) {
            group?.get('dropoffPoint')?.setValue({
              ...dropoffPoint,
              deliveryCharge: matchedDropPoint.charges, // adjust property as needed
            });
          }
        });
        // NOTE: Do not trigger updateDropOff here; selecting a delivery method
        // should not cause a recalculation of delivery charges on the backend.
        // We only update the local form for UI consistency and rely on the
        // existing subscription to refresh prices when addresses actually change.
        this.updateDropOff();
        console.log('bruhhdeep');
      }

      if (
        this.selectedDeliveryMethod?.id == 7 &&
        !this.isSaverPlanBottomSheetShow
      ) {
        this.openSaverBottomSheet();
        if (this.form?.get('isScheduleDelivery')?.value) {
          this.form?.get('isScheduleDelivery')?.setValue('');
          this.form?.get('scheduleDelivery')?.setValue('');
        }
        this.updateDropOff();
        console.log('bruhhdeep');
      }
    }
    this.updateDropOff();
    console.log('bruhhdeep');
  }

  openSaverBottomSheet() {
    this._bottomSheet
      .open(SaverDeliveryMethodInfoComponent, {
        panelClass: ['bottomSheetWrapper'],
        disableClose: false,
      })
      .afterDismissed()
      .subscribe(() => {
        this.isSaverPlanBottomSheetShow = true;
        this.saveDataInfoLocal();
      });
  }

  onSelectPaymentMethod(selectedItem, selectedIndex) {
    this.paymentMethods.forEach((item) => (item.isSelected = 0));
    if (!this.form?.get('pickupLocationAddress')?.value) {
      this.showSelectionError('pickupLocationAddress');
      return;
    } else if (
      !this.dropoffLocations?.controls?.[
        this.dropoffLocations?.controls?.length - 1
      ]?.get('dropoffPointAddress')?.value
    ) {
      this.showSelectionError('dropoffPointAddress');
      return;
    } else if (!this.selectedDeliveryMethod) {
      this.showSelectionError('deliveryMethod');
      return;
    } else if (
      this.selectedDeliveryMethod?.pdasWalletAmount == 0 &&
      selectedIndex == 2
    ) {
      this.showSelectionError('noEnoughBalance');
      return;
    } else {
      selectedItem.isSelected = 1;

      this.selectedPaymentMethod = selectedItem;

      // if(this.selectedPaymentMethod?.id !== 1){
      // 	this.selectedCashService = null
      // }
      console.log('this.selectedPaymentMethod', this.selectedPaymentMethod);

      const params = {
        isPdasWalletApplied: this.selectedPaymentMethod.id == 3 ? 1 : 0,
        changeStatus: 1,
      };

      this.updateDocWithParams(params);

      this.saveDataInfoLocal();
    }
  }

  onSelectCashSerive(selectedIndex) {
    this.selectLogic(this.cashSerive, selectedIndex);
    console.log('thiscashSerive===>==>=>', this.cashSerive);
    this.selectedCashService = this.cashSerive.filter(
      (item) => item.isSelected
    )[0];
    console.log('this.selectedCashService', this.selectedCashService);

    this.saveDataInfoLocal();
  }

  selectLogic(arr, selectedIndex) {
    arr.forEach((element, index): any => {
      if (selectedIndex == index) {
        return (element.isSelected = 1);
      } else {
        element.isSelected = 0;
      }
    });
  }

  public isTotalCashCollection() {
    if (this.dropoffLocations?.controls?.length) {
      return this.dropoffLocations?.controls?.some(
        (group) => Number(group?.get('dropoffPoint')?.value?.collectCash) > 0
      );
    } else {
      return false;
    }
  }

  getTotalCashCollection() {
    if (this.dropoffLocations?.controls?.length) {
      let sumOfCashCollected = 0;
      this.orderDoc?.selectedAddress?.to.forEach((item) => {
        if (item.collectCash > 0) {
          sumOfCashCollected += parseFloat(item.collectCash);
        }
      });
      return sumOfCashCollected;
    } else {
      return false;
    }
  }

  /* 
    FORM FUNCTIONS
  */

  // create form here.
  private createForm(data = undefined): void {
    this.form = this._fb.group({
      pickupLocationAddress: ['', Validators.required],
      pickupLocation: ['', Validators.required],
      dropoffLocations: this._fb.array([]),
      isScheduleDelivery: [''],
      scheduleDelivery: [''],
      isPromoApplied: [false],
      useTip: [''],
      tipAmount: [''],

      isPhlenuCashApplied: [false],
      isLoadingFeeApplied: [''],
      promoTitle: [''],
      comment: [''],
      attachmentInfo: [''],
      attachment: [''],
      globalPackageSize: [
        '',
        this.isHeavyItemAndRelocateOrder
          ? Validators.required
          : Validators.nullValidator,
      ],
    });
  }

  preventInvalidKeys(event: KeyboardEvent) {
    const invalidChars = ['-', '+', 'e', 'E'];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  // form array for dropoffLocation
  get dropoffLocations(): FormArray {
    return (
      (this.form?.get('dropoffLocations') as FormArray) || new FormArray([])
    );
  }

  // ADD NEW DROP LOCATION FORM GROUP
  public addDropRow(index?, isOpenDrop: boolean = true): void {
    // console.log("index", index);

    (<FormArray>this.form?.get('dropoffLocations')).push(
      this._fb.group({
        dropoffPointAddress: ['', Validators.required],
        dropoffPoint: ['', Validators.required],
        packageSize: [
          '',
          this.isHeavyItemAndRelocateOrder ? Validators.required : null,
        ],
      })
    );

    if (isOpenDrop)
      if (index || index == 0) {
        this.onDropOffLocation(this.dropoffLocations['controls'], index + 1);
      }
  }

  // REMOVE DROP LOCATION FORM GROUP
  public removeDropLocation(dropIndex): void {
    // remove form firebase
    if (this.dropoffLocations?.controls?.length == 1) {
      this.dropoffLocations?.controls?.[dropIndex]
        ?.get('dropoffPointAddress')
        ?.setValue('');
      this.dropoffLocations?.controls?.[dropIndex]
        ?.get('dropoffPoint')
        ?.setValue('');
      this.dropoffLocations?.controls?.[dropIndex]
        ?.get('packageSize')
        ?.setValue('');
    } else {
      (<FormArray>this.form?.get('dropoffLocations')).removeAt(dropIndex);
    }

    this.updateDropOff();
  }

  /* 
    ERROR'S HANDLING
  */

  showSelectionError(errorfor) {
    switch (errorfor) {
      case 'pickupLocationAddress':
        this._matSnackBar.open(appMessages.enterPickupLocation, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'dropoffPointAddress':
        this._matSnackBar.open(appMessages.enterDropOffLocation, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'deliveryMethod':
        this._matSnackBar.open(appMessages.selectDeliveryMethod, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'noEnoughBalance':
        this._matSnackBar.open(appMessages.noEnoughBalance, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'promoNotAvailable':
        this._matSnackBar.open(appMessages.invalidPromoCode, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'promoExpired':
        this._matSnackBar.open(appMessages.expiredPromo, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'handlingItem':
        this._matSnackBar.open(appMessages.selectHandlingItem, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'paymentMethod':
        this._matSnackBar.open(appMessages.selectPaymentmethod, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'showSelectionError':
        this._matSnackBar.open(appMessages.cashOnServiceType, 'OKAY', {
          duration: 4000,
        });
        break;
      case 'packageSizeEmpty':
        this._matSnackBar.open(appMessages.packageSizeEmpty, 'OKAY', {
          duration: 4000,
        });
        break;
      default:
        break;
    }
  }

  onChangeTipAmount() {
    if (this.form?.get('tipAmount')?.value) {
      const isTip = this.form?.get('useTip')?.value;
      const tipAmount = this.form?.get('tipAmount')?.value || 0;
      const params = {
        isTipGiven: !!isTip ? 1 : 0,
        tipAmount: tipAmount,
        tipId: 0,
        changeStatus: 1,
      };
      this.updateDocWithParams(params);
    } else {
      this.form?.get('useTip')?.setValue(false);
    }
  }

  /* 
    FROM FUNCTION FINISHED HERE...
  */

  // OPEN PICKUP LOCATION DIALOG.
  public onPickupLocation(): void {
    this.drawerContext = { type: 'pickup' };
    this.openPickupDrawer();
  }

  // OPEN DROPOFF LOCATION DIALOG.
  public onDropOffLocation(groups, groupIndex: number): void {
    this.activeDropoffIndex = groupIndex; // Set the active index
    this.drawerContext = { type: 'dropoff', dropoffIndex: groupIndex };

    // Use the validation helper method first
    if (this.validateLocationSelection('dropoff', groupIndex)) {
      // Firebase document should already be initialized when pickup was selected
      // Just open the drawer for dropoff location selection
      this.openPickupDrawer();
    }
  }

  // Ensure Firebase document is properly initialized
  private ensureFirebaseDocumentInitialized(): void {
    if (!this.docIdFire) {
      console.log('Firebase document not initialized. Initializing now...');
      this.initializeOrder();

      // Wait for the document to be created
      const checkInterval = setInterval(() => {
        if (this.docIdFire) {
          console.log(
            'Firebase document initialized successfully:',
            this.docIdFire
          );
          clearInterval(checkInterval);

          // Subscribe to document changes if not already subscribed
          if (!this.unsubscribe$.closed) {
            this.subscribeDoc();
          }

          // Update pickup address in Firebase if it was already selected
          this.updatePickupAddressInFirebase();
        }
      }, 500);

      // Clear interval after 10 seconds to prevent infinite checking
      setTimeout(() => {
        clearInterval(checkInterval);
        if (!this.docIdFire) {
          console.error(
            'Failed to initialize Firebase document after 10 seconds'
          );
        }
      }, 10000);
    } else {
      // If Firebase is already initialized, just update pickup address
      this.updatePickupAddressInFirebase();
    }
  }

  // OPTIMIZATION: Only initialize Firebase when user actually starts order flow
  private shouldInitializeFirebase(): boolean {
    // Initialize when user has selected pickup location
    return !!(
      (
        this.form?.get('pickupLocationAddress')?.value &&
        this.form?.get('pickupLocation')?.value &&
        !this.docIdFire
      ) // Not already initialized
    );
  }

  // Update pickup address in Firebase if it was already selected
  private updatePickupAddressInFirebase(): void {
    const pickupLocation = this.form?.get('pickupLocation')?.value;
    const pickupLocationAddress = this.form?.get(
      'pickupLocationAddress'
    )?.value;

    if (pickupLocation && pickupLocationAddress && this.docIdFire) {
      console.log('Updating pickup address in Firebase:', pickupLocation);
      const params = {
        'selectedAddress.from': [pickupLocation],
        changeStatus: 1,
      };
      this.updateDocWithParams(params);
    } else {
      console.log('Cannot update pickup address in Firebase:', {
        hasPickupLocation: !!pickupLocation,
        hasPickupAddress: !!pickupLocationAddress,
        hasDocIdFire: !!this.docIdFire,
      });
    }
  }

  public openPromoCodeDialog(): void {
    const dialog = this._matDialog.open(PromoCodesDialogComponent, {
      autoFocus: false,
      width: '610px',
      disableClose: true,
      data: {
        heading: 'Promo code',
        orderType: 'standard',
        promoList: this.promoCodeList.length ? this.promoCodeList : [],
      },
    });

    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.appliedPromo = res;
        this.form?.get('isPromoApplied')?.setValue(true);
        this.form?.get('promoTitle')?.setValue(res.promoTitle);
        const params = {
          isPromoCodeApplied: 1,
          promoTitle: res.promoTitle,
          changeStatus: 1,
          promoStatus: 0,
        };
        this.updateDocWithParams(params);

        setTimeout(() => {
          this.updateOrderDoc()
            .pipe(take(1))
            .subscribe((updatedDoc: any) => {
              if (
                updatedDoc?.deliveryCharges?.length &&
                updatedDoc?.isPromoCodeApplied &&
                this.selectedDeliveryMethod
              ) {
                const tempSelectedDeliveryChanges =
                  updatedDoc?.deliveryCharges.filter(
                    (item) => item.id == this.selectedDeliveryMethod.id
                  );
                console.log(
                  'tempSelectedDeliveryChanges',
                  tempSelectedDeliveryChanges
                );
                if (!tempSelectedDeliveryChanges?.length) return;
                this.checkPromoValidation(tempSelectedDeliveryChanges[0]);
              }
            });
        }, 1500);
      } else {
        this.appliedPromo = null;
        this.removePromoCode();
      }
    });
  }

  private checkPromoValidation(promoResponse): void {
    console.log('checkPromoValidation CALLED');
    if (!promoResponse) return;
    if (promoResponse?.promoResponse) {
      const promoStatus = promoResponse?.promoResponse.promoStatus;
      if (promoStatus == 2 || promoStatus == 3) {
        this.showSelectionError('promoNotAvailable');
        this.form?.get('promoTitle')?.markAllAsTouched();
        this.form?.get('promoTitle')?.setErrors({ inValid: true });
        // this._cd
      } else if (promoStatus == 4 || promoStatus == 5) {
        this.showSelectionError('promoExpired');
        this.form?.get('promoTitle')?.markAllAsTouched();
        this.form?.get('promoTitle')?.setErrors({ inValid: true });
      }
    }
  }

  public removePromoCode(): void {
    this.form?.get('isPromoApplied')?.setValue(false);
    this.form?.get('promoTitle')?.setValue('');
    const params = {
      isPromoCodeApplied: 0,
      promoTitle: '',
      changeStatus: 1,
      promoStatus: 0,
    };
    this.updateDocWithParams(params);
  }

  public onAttachmentSelect(event): void {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this._auth.uploadFile(file).subscribe((res: any) => {
          if (res.response) {
            this._matSnackBar.open(res.message, 'OKAY', { duration: 2000 });
            this.form?.get('attachment')?.markAsPristine();
            this.form?.get('attachment')?.markAsUntouched();
            this.attachmentUploadedUrl = res.data.url;
            this.isAttachmentUploaded = true;
            this.saveDataInfoLocal();
          }
        });
      };
    }
  }

  public onRemoveAttachment(): void {
    this.form?.get('attachment')?.setValue('');
    this.isAttachmentUploaded = false;
    this.attachmentUploadedUrl = '';
  }

  // DROPOFF ADD/UPDATE/REMOVE
  public updateDropOff() {
    console.log('bruhhupdate', this.dropPointsToShow);

    let tempDropOff = [];
    this.dropoffLocations?.controls?.forEach((group) => {
      const dropoffPoint = group?.get('dropoffPoint')?.value;
      const dropoffAddress = group?.get('dropoffPointAddress')?.value;

      // Only add to array if both dropoffPoint and dropoffAddress have valid values
      if (
        dropoffPoint &&
        dropoffAddress &&
        dropoffAddress.trim() !== '' &&
        dropoffPoint.address &&
        dropoffPoint.address.trim() !== ''
      ) {
        tempDropOff.push(dropoffPoint);
      }
    });
    console.log('bruhh', tempDropOff);

    // Sanitize dropoffs to avoid sending UI-only/state fields back to backend
    const sanitizedDropoffs = this.sanitizeDropoffsForUpdate(tempDropOff);

    // Avoid redundant writes if nothing material changed
    const newSnapshot = JSON.stringify(sanitizedDropoffs);
    const currentDocSnapshot = JSON.stringify(
      this.sanitizeDropoffsForUpdate(this.orderDoc?.selectedAddress?.to || [])
    );
    if (
      newSnapshot === this.lastSelectedToSnapshot ||
      newSnapshot === currentDocSnapshot
    ) {
      this.isDataLoading = false;
      this.isDeliveryChargeLoading = false;
      return;
    }

    const params = {
      'selectedAddress.to': sanitizedDropoffs,
      changeStatus: 1,
    };

    // Set loading state to show that calculation is in progress
    this.isDataLoading = true;
    this.isDeliveryChargeLoading = true;
    this.lastSelectedToSnapshot = newSnapshot;

    // Use immediate update for dropoff changes as they're critical for pricing
    this.updateDocWithParams(params);

    // Rely on the active Firestore subscription to update delivery charges.
    // Avoid immediate polling to prevent double updates and flickering totals.

    this.setDropPoints();
  }

  private unsubscribeFromDocument() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.unsubscribe$ = new Subject<void>(); // Reinitialize to allow resubscription
  }

  private resubscribeToDocument() {
    // this.unsubscribe$ = new Subject<void>(); // Reinitialize to allow resubscription
    this.subscribeDoc();
  }

  private async deleteDocument() {
    const docSnapshot = await this.afs
      .collection(OrderPool)
      .doc(this.docIdFire)
      .delete();
  }

  /* 
    FIREBASE QUERY'S FUNTIONS
  */

  // get/update deliveryCharges by firebase.
  updateOrderDoc() {
    if (!this.docIdFire) {
      console.log(
        'Firebase document not initialized yet. Returning empty observable.'
      );
      // Return an empty observable when Firebase is not initialized
      return new Observable();
    }

    console.log('Accessing Firebase document with docIdFire:', this.docIdFire);
    return this.afs.collection(OrderPool).doc(this.docIdFire).valueChanges();
  }

  // OPTIMIZATION: Enhanced Firebase update batching with better grouping
  updateDocWithParams(params) {
    if (params['changeStatus']) this.isDataLoading = true;

    // Only update Firebase if document is initialized
    if (!this.docIdFire) {
      console.log(
        'Firebase document not initialized yet. Skipping update until pickup location is selected.'
      );
      return;
    }

    // OPTIMIZATION: Enhanced critical update detection
    if (this.isCriticalUpdate(params)) {
      // Immediate update for critical operations
      if (this.docIdFire) {
        const docRef = this.afs.collection(OrderPool).doc(this.docIdFire);
        docRef.update(params);
      }
    } else {
      // OPTIMIZATION: Enhanced batching for non-critical updates
      this.batchFirebaseUpdate(params);
    }
  }

  // OPTIMIZATION: Enhanced critical update detection
  private isCriticalUpdate(params: any): boolean {
    // Critical updates that affect pricing or order flow
    const criticalKeys = [
      'selectedAddress.from',
      'selectedAddress.to',
      'changeStatus',
      'isSchedule',
      'scheduleDate',
      'sandingItemKey', // Package selection affects pricing
      'sandingItemName',
      'totalCashCollected', // Cash collection affects pricing
    ];

    return Object.keys(params).some((key) => criticalKeys.includes(key));
  }

  // OPTIMIZATION: Enhanced Firebase update batching
  private batchFirebaseUpdate(params: any) {
    // Merge the new params with pending updates
    this.pendingFirebaseUpdates = { ...this.pendingFirebaseUpdates, ...params };

    // Clear existing timeout
    if (this.firebaseUpdateTimeout) {
      clearTimeout(this.firebaseUpdateTimeout);
    }

    // OPTIMIZATION: Dynamic debounce delay based on update frequency
    const debounceDelay = this.getDynamicDebounceDelay();

    // Set new timeout for batched update
    this.firebaseUpdateTimeout = setTimeout(() => {
      this.executeFirebaseUpdate();
    }, debounceDelay);
  }

  // OPTIMIZATION: Dynamic debounce delay based on update frequency
  private getDynamicDebounceDelay(): number {
    const pendingUpdateCount = Object.keys(this.pendingFirebaseUpdates).length;

    // Shorter delay for fewer updates, longer for many
    if (pendingUpdateCount <= 2) {
      return 500; // 500ms for 1-2 updates
    } else if (pendingUpdateCount <= 5) {
      return 1000; // 1s for 3-5 updates
    } else {
      return 2000; // 2s for 6+ updates
    }
  }

  // OPTIMIZATION: Enhanced Firebase update execution
  private executeFirebaseUpdate() {
    if (this.docIdFire && Object.keys(this.pendingFirebaseUpdates).length > 0) {
      const docRef = this.afs.collection(OrderPool).doc(this.docIdFire);

      // OPTIMIZATION: Log batch size for monitoring
      console.log(
        `Executing batched Firebase update with ${Object.keys(this.pendingFirebaseUpdates).length
        } fields`
      );

      docRef
        .update(this.pendingFirebaseUpdates)
        .then(() => {
          console.log('Batched Firebase update successful');
        })
        .catch((error) => {
          console.error('Batched Firebase update failed:', error);
          // OPTIMIZATION: Retry failed batch updates
          this.retryFailedBatchUpdate();
        });

      // Clear pending updates
      this.pendingFirebaseUpdates = {};
      this.firebaseUpdateTimeout = null;
    }
  }

  // OPTIMIZATION: Retry logic for failed batch updates
  private retryFailedBatchUpdate(retryCount = 0): void {
    const maxRetries = 2;
    if (
      retryCount < maxRetries &&
      Object.keys(this.pendingFirebaseUpdates).length > 0
    ) {
      console.log(
        `Retrying batch update (attempt ${retryCount + 1}/${maxRetries})`
      );
      setTimeout(() => {
        this.executeFirebaseUpdate();
      }, 1000 * (retryCount + 1));
    } else if (retryCount >= maxRetries) {
      console.error('Failed to execute batch update after maximum retries');
      // Clear pending updates to prevent memory leaks
      this.pendingFirebaseUpdates = {};
      this.firebaseUpdateTimeout = null;
    }
  }

  checkZeroNumber(value) {
    if (String(value).split('')[0] == '0') {
      return true;
    } else {
      return false;
    }
  }

  phoneNumberTrim(field) {
    return this.checkZeroNumber(field)
      ? this.selectedCountryCode == '+233'
        ? String(field).split('').slice(1, 10).join('')
        : String(field).split('').slice(1, 11).join('')
      : field;
  }

  onConfirm() {
    // if (this.isHeavyItemAndRelocateOrder) {
    // 	this.dropoffLocations.controls.map((group) => {
    // 		group.get('packageSize').setValue(this.form.get('globalPackageSize').value)
    // 	})
    // }

    console.log('the upadated orderDoc', this.orderDoc);

    console.log('form', this.form);
    console.log('this.isPharmacyOrder', this.isPharmacyOrder);

    console.log(
      'this.orderDoc?.paymentMethod?.length',
      this.orderDoc?.paymentMethod?.length
    );
    console.log('this.selectedPaymentMethod', !this.selectedPaymentMethod);

    // handle isPharmacyOrder payment methods
    // if(!this.selectedPaymentMethod && this.isPharmacyOrder) this.onSelectPaymentMethod(1); this.selectedCashService
    if (this.isPharmacyOrder) {
      if (this.orderDoc?.paymentMethod?.length) {
        if (!this.selectedPaymentMethod) {
          this.showSelectionError('paymentMethod');
          this.isConfirmingOrder = false;
          return;
        }
      } else {
        this.onSelectPaymentMethod(
          this.paymentMethods.filter((item) => item.id == 1)[0],
          0
        );
        this.onSelectCashSerive(0);
      }
    } else {
      if (this.selectedPaymentMethod?.id == 1 && !this.selectedCashService) {
        this.showSelectionError('showSelectionError');
        this.isConfirmingOrder = false;
        return;
      }
    }

    if (
      this.form?.invalid ||
      !this.handlingItem ||
      !this.selectedDeliveryMethod ||
      !this.selectedPaymentMethod
    ) {
      if (!this.form?.get('pickupLocationAddress')?.value) {
        this.showSelectionError('pickupLocationAddress');
        this.form?.get('pickupLocationAddress')?.markAsTouched();
      } else if (
        !this.dropoffLocations?.controls?.[
          this.dropoffLocations?.controls?.length - 1
        ]?.get('dropoffPointAddress')?.value
      ) {
        this.showSelectionError('dropoffPointAddress');
      } else if (!this.handlingItem) {
        this.showSelectionError('handlingItem');
      } else if (!this.selectedDeliveryMethod) {
        this.showSelectionError('deliveryMethod');
      } else if (!this.selectedPaymentMethod && !this.isPharmacyOrder) {
        this.showSelectionError('paymentMethod');
      } else if (
        this.isHeavyItemAndRelocateOrder &&
        !this.form?.get('globalPackageSize')?.value
      ) {
        this.showSelectionError('packageSizeEmpty');
      }
    } else {
      console.log('we are in else');

      this.unsubscribeFromDocument();

      this.saveDataInfoLocal();

      this.isConfirmingOrder = true;

      const modifiedpickupLocationFormData = JSON.parse(
        JSON.stringify(this.form?.get('pickupLocation')?.value)
      );
      modifiedpickupLocationFormData['mobile'] = this.phoneNumberTrim(
        this.form?.get('pickupLocation')?.value?.mobile
      );
      modifiedpickupLocationFormData['phone'] =
        modifiedpickupLocationFormData['mobile'];

      this.dropoffLocations?.controls?.map((group) => {
        group.get('dropoffPoint').value['mobile'] = this.phoneNumberTrim(
          group.get('dropoffPoint').value.mobile
        );
        group.get('dropoffPoint').value['phone'] =
          group.get('dropoffPoint').value['mobile'];
      });

      const payload = {
        region: this.orderDoc.region,
        vehicleType:
          this.selectedDeliveryMethod.id == 7
            ? 2
            : this.selectedDeliveryMethod.id,
        pickupAddresses: !!this.form?.get('pickupLocationAddress')?.value
          ? {
            ...modifiedpickupLocationFormData,
            PDAS_Id: this.orderDoc.PDAS_Id,
            isDefault: 1,
          }
          : null,
        dropAddresses: this.dropoffLocations?.controls?.map((group) => ({
          ...group.get('dropoffPoint').value,
          PDAS_Id: this.orderDoc.PDAS_Id,
          isDefault: 1,
          heavyAttachment: this.attachmentUploadedUrl || '',
        })),
        // paymentMethod: this.selectedPaymentMethod.id == 4 ? 3 : this.selectedPaymentMethod.id,
        // paymentMethod: this.selectedPaymentMethod.id == 2 ? 3 : this.selectedPaymentMethod.id,
        // paymentMethod: this.selectedPaymentMethod.id == 1 ? this.selectedCashService.id : this.selectedPaymentMethod.id == 2 ? 3 : this.selectedPaymentMethod.id == 3 ? 4 : 0,
        // paymentMethod: this.isPharmacyOrder == false ? this.selectedPaymentMethod.id == 4 ? 3 : this.selectedPaymentMethod.id == 1 ? this.selectedCashService.id : this.selectedPaymentMethod.id  == 2 ? 3 : this.selectedPaymentMethod.id : this.orderDoc?.paymentMethod?.length ? 4 : 2,
        paymentMethod:
          this.isPharmacyOrder == false
            ? this.selectedPaymentMethod.id == 4
              ? 3
              : this.selectedPaymentMethod.id == 1
                ? this.selectedCashService.id
                : this.selectedPaymentMethod.id == 2
                  ? 3
                  : this.selectedPaymentMethod.id
            : this.orderDoc?.paymentMethod?.length
              ? 3
              : 2,

        isPromoCodeApplied:
          this.orderDoc.isPromoCodeApplied &&
            this.selectedDeliveryMethod?.promoResponse?.promoStatus == 1
            ? 1
            : 0,
        promoId: this.appliedPromo?.id || 0,
        promoAmount:
          this.selectedDeliveryMethod?.promoResponse?.promoDiscountAmount || 0,
        promoDiscountValue:
          this.selectedDeliveryMethod?.promoResponse?.promoDiscountValue || 0,
        promoDiscountType:
          this.selectedDeliveryMethod?.promoResponse?.discountType || 0,

        tipAmount: this.orderDoc.tipAmount,
        isTipGiven: this.orderDoc.isTipGiven,

        discount: this.selectedDeliveryMethod.discountinpercentage,
        imageURL: this.attachmentUploadedUrl || '',
        comment: this.form?.get('comment')?.value,

        isHeavyRelocationOrder: this.isHeavyItemAndRelocateOrder ? 1 : 0,

        sandingItemKey: this.handlingItem.id,
        sandingItemName: this.form?.get('attachmentInfo')?.value
          ? this.form?.get('attachmentInfo')?.value
          : this.handlingItem.title,
        sandingItemType: this.handlingData.filter((item) => item.isSelected)[0]
          .id,
        distance: this.selectedDeliveryMethod?.distance || '',
        isSchedule: this.orderDoc.isSchedule || '',

        isWalletUsed: this.form?.get('isPhlenuCashApplied')?.value ? 1 : 0,
        walletAmount: this.selectedDeliveryMethod?.phlenuCashAmount || 0,

        pdasWalletAmount:
          this.selectedDeliveryMethod?.pdasWalletUsedAmount || 0,
        isPdasWalletUsed: this.orderDoc?.isPdasWalletApplied ? 1 : 0,

        scheduleDate: this.orderDoc.scheduleDate
          ? new Date(this.orderDoc.scheduleDate).toISOString()
          : new Date().toISOString(),
        time: this.orderDoc.isSchedule
          ? formatDate(
            new Date(this.orderDoc.scheduleDate),
            'yyyy-MM-dd hh:mm a',
            'en-US'
          )
          : formatDate(new Date(), 'yyyy-MM-dd hh:mm a', 'en-US'),

        pdasCommisionPercentage:
          this.selectedDeliveryMethod?.pdasCommisionPercentage,
        isPdasCommisionApplied:
          this.selectedDeliveryMethod?.isPdasCommisionApplied,
        pdasCommisionAmount: this.selectedDeliveryMethod?.cashBack,
        conveniencePercentage: this.orderDoc.conveniencePercentage,
        isConvenienceApply: this.orderDoc.isConvenienceApply,
        convenienceFee: this.selectedDeliveryMethod?.convenienceFee,
        percentageOnCashCollect:
          this.selectedDeliveryMethod?.percentageOnCashCollect || 0,
        feeOnCashCollect: this.selectedDeliveryMethod?.feeOnCashCollect || 0,

        damageCoverPercentage: this.orderDoc.damageCoverPercentage || 0,
        damageCoverAmount: this.selectedDeliveryMethod?.damageCoverAmount || 0,
        totalCashCollected: this.isTotalCashCollection()
          ? this.getTotalCashCollection()
          : 0,
        isLoadingFeeApplied: this.form?.get('isLoadingFeeApplied')?.value
          ? 1
          : 0, // applicable in ng case.
        loadingFee: this.selectedDeliveryMethod?.loadingFee,
        isHeavyAttachmentApplied: this.handlingMethods.filter(
          (item) => item.id == 3 && item.isSelected
        ).length
          ? 1
          : 0,

        calculateWithCar: this.selectedDeliveryMethod?.id === 3 ? 1 : 0,
        calculateWithTruck:
          this.selectedDeliveryMethod?.id === 5 ||
            this.selectedDeliveryMethod?.id === 6
            ? 1
            : 0,
        isWebOrder: 1,

        orderPackageSize: this.form?.get('globalPackageSize')?.value
          ? this.form?.get('globalPackageSize')?.value
          : 0,

        fbDocId: this.docIdFire,
        isWhatsappOrder: this.redirectByWA ? 1 : 0,
        isSaverPlanOn:
          (this.isSeverPlan && this.selectedDeliveryMethod.id) == 7 ? 1 : 0,
        isPharmacyOrder: this.isPharmacyOrder ? 1 : 0,
        userId: this.orderDoc?.userId ? this.orderDoc?.userId : null,

        perishablesIncreasePercent: this.orderDoc?.perishablesIncreasePercent,
        motorBikePlatformPriceIncrease:
          this.orderDoc?.motorBikePlatformPriceIncrease,
        carPlatformPriceIncrease: this.orderDoc?.carPlatformPriceIncrease,
        conveniencePercentageOffline:
          this.orderDoc?.conveniencePercentageOffline,
        isOfflinePdas: this.orderDoc?.isOfflinePdas,

        webAppModelName: this.deviceInfo?.webAppModelName,
      };

      if (this.orderDoc?.pharmacyAdditionalkm)
        payload['pharmacyAdditionalkm'] = this.orderDoc?.pharmacyAdditionalkm;

      if (this.orderDoc?.pharmacyAdditionalkmCharge)
        payload['pharmacyAdditionalkmCharge'] =
          this.orderDoc?.pharmacyAdditionalkmCharge;

      if (this.orderDoc?.pharmacyFirstKm)
        payload['pharmacyFirstKm'] = this.orderDoc?.pharmacyFirstKm;

      if (this.orderDoc?.pharmacyPriceForOtherDay)
        payload['pharmacyPriceForOtherDay'] =
          this.orderDoc?.pharmacyPriceForOtherDay;

      if (this.orderDoc?.pharmacyPriceForsunday)
        payload['pharmacyPriceForsunday'] =
          this.orderDoc?.pharmacyPriceForsunday;

      if (this.orderDoc?.pharmacySpecificLocationCharge)
        payload['pharmacySpecificLocationCharge'] =
          this.orderDoc?.pharmacySpecificLocationCharge;

      if (!this.isHeavyItemAndRelocateOrder) {
        payload.dropAddresses = payload.dropAddresses.map(
          ({ packageSize, ...rest }) => ({ ...rest })
        );
        delete payload.orderPackageSize;
      }

      console.log('finalpayloadpaymentMethod', payload);

      this._auth.confirmStandardOrder(payload).subscribe((res: any) => {
        console.log('RES', res);
        if (res?.response == 1) {
          if (res?.data?.paymentUrl && res?.data?.isPaid) {
            this._matSnackBar.open('Processing.', 'OKAY', { duration: 5000 });
          } else {
            // this._matSnackBar.open(res.message, 'OKAY', { duration: 5000 });
          }
          this.confirmOrderRes = res;
          this.checkCaseAndNavigation(res);
        } else if (res?.response == 2) {
          // this._matSnackBar.open(res.message, 'OKAY', {duration : 5000});
          this.isOrderConfirmed = true;
          if (this.isHeavyItemAndRelocateOrder) {
            if (localStorage.getItem('PENDINGHEAVYORDERDATA')) {
              this.addGoogleTags();
              this.addFbEvent('standardheavy', res?.data);
              localStorage.removeItem('PENDINGHEAVYORDERDATA');
            }
          } else {
            if (localStorage.getItem('PENDINGORDERDATA')) {
              this.addGoogleTags();
              this.addFbEvent('standard', res?.data);
              // this._router.navigate(['/order-successful/'+ res?.data?.order_id])
              localStorage.removeItem('PENDINGORDERDATA');
            }
          }

          this.confirmOrderRes = res;
          this.checkCaseAndNavigation(res);
        }
        // if delivery window close
        else if (res?.response == 3) {
          this._matSnackBar.open(res.message, 'OKAY', { duration: 5000 });
          this.form.enable();
          this.isConfirmingOrder = false;
          this.resubscribeToDocument();
        } else if (res.response === 0) {
          this.driverUnavailableAlert();
          this.resubscribeToDocument();
        } else {
          this.form.enable();
          this.isConfirmingOrder = false;
          this.resubscribeToDocument();
        }
      });
    }
  }

  addFbEvent(type, data) {
    const orderData = {
      selectedDeliveryMethod: this.selectedDeliveryMethod,
      orderDoc: this.orderDoc,
      resData: data,
    };
    this._FacebookApiService.sendPurchaseEvent(type, false, orderData);
  }

  addGoogleTags() {
    // get user data
    const authUser = localStorage.getItem('authUser');
    if (!authUser) {
      console.error('No authUser found in localStorage for Google Tags');
      return;
    }
    const user = JSON.parse(authUser);
    // Add the event snippet for Purchase Conversion
    const item = this.selectedDeliveryMethod?.dropPoint?.length
      ? this.selectedDeliveryMethod.dropPoint.map((item, i) => {
        return {
          item_id: item.id,
          item_name: item.name,
          affiliation: 'Phlenu',
          coupon: this.orderDoc.promoTitle,
          discount: Math.round(item.charges - item.payToCustomer),
          index: i,
          item_brand: 'Phlenu',
          item_category: this.selectedHandling?.title || '',
          price: item.payToCustomer,
          quantity: i + 1,
        };
      })
      : [];
    // Adding data to the GTM Data Layer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'purchase',
      name: user.firstName,
      email: user.email,
      phone: user.phoneCode + '' + user.phone,
      ecommerce: {
        transaction_id: this.orderDoc.uniqueId,
        value: this.selectedDeliveryMethod?.netTotal,
        tax: '',
        shipping: '',
        currency: this.selectedDeliveryMethod?.currency,
        price: this.selectedDeliveryMethod?.netTotal,
        coupon: this.orderDoc.promoTitle,
        items: JSON.parse(JSON.stringify(item)),
      },
    });
  }

  driverUnavailableAlert() {
    const dialog = this._matDialog.open(NoDriverAvailableDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      autoFocus: false,
      width: '480px',
      disableClose: false,
    });

    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.form.enable();
        this.isConfirmingOrder = false;
      }
    });
  }

  allReset() {
    // this.form.enable();
    this.form?.reset();
    this.selectedDeliveryMethod = null;
    this.dropPointsToShow = [];
    this.selectedPaymentMethod = null;
    this.orderDoc = null;
    this.handlingMethods.map((item) => (item.isSelected = 0));
    this.deliveryMethods.map((item) => (item.isSelected = 0));
    this.paymentMethods.map((item) => (item.isSelected = 0));
    this.cashSerive.map((item) => (item.isSelected = 0));
    this.isConfirmingOrder = false;
    // const user = JSON.parse(localStorage.getItem('authUser'))
    localStorage.removeItem('PENDINGORDERDATA');
    this._auth.getDashboardData({});
  }

  onPhlenuCashToggle(event: any) {
    const walletAmount =
      this.selectedDeliveryMethod?.walletAmt ||
      this.selectedDeliveryMethod?.phlenuCashAmount ||
      0;
    if (!walletAmount) {
      setTimeout(() => {
        this.form?.get('isPhlenuCashApplied')?.setValue(false);
        this.form?.get('isPhlenuCashApplied')?.updateValueAndValidity();
      }, 0);
      this._matSnackBar.open(appMessages.plenuCaseUnavailable, 'OKAY', {
        duration: 4000,
      });
    } else if (walletAmount < 1) {
      setTimeout(() => {
        this.form?.get('isPhlenuCashApplied')?.setValue(false);
        this.form?.get('isPhlenuCashApplied')?.updateValueAndValidity();
      }, 0);
      this._matSnackBar.open(appMessages.noEnoughPhlenuCase, 'OKAY', {
        duration: 4000,
      });
    } else {
      const params = {
        isPhlenuCashApplied: event.checked && walletAmount ? 1 : 0,
        changeStatus: 1,
      };
      this.updateDocWithParams(params);
    }
  }

  /* 
    after order confirm handle success
  */

  checkCaseAndNavigation(response) {
    // console.log("response", response);
    if (response.data.paymentUrl && response.data.isPaid) {
      this.paymentDialog(response.data);
    } else {
      const dialog = this._matDialog.open(InfoDialogComponent, {
        panelClass: ['commonDialogWrapper'],
        backdropClass: 'dialogBackdrop',
        autoFocus: false,
        width: '510px',
        disableClose: false,
        data: {
          heading: 'Order!',
          message: response.message,
          type: 'order',
        },
      });
      dialog.afterClosed().subscribe(() => {
        this.allReset();
        if (this.redirectByWA) {
          window.open(
            `https://wa.me/${localStorage.getItem('country') == 'Ghana'
              ? '+233530460178'
              : '+2349166329008'
            }`,
            '_self'
          );
        } else {
          console.log('response', response);
          this._router.navigate(['orders/detail/' + response.data.order_id]);
        }
      });
    }
  }

  paymentDialog(data) {
    window.open(data.paymentUrl, '_self');
    this.allReset();
  }

  goBack() {
    if (
      this.form?.get('pickupLocationAddress')?.value &&
      !this.isConfirmingOrder &&
      !this.hardReload
    ) {
      const confirmed = confirm(
        'WARNING: If you leave this page, your form details will be lost and you will need to place your order again.'
      );

      if (confirmed) {
        this.allReset();
        this._router.navigate(['/']);
      }
    } else {
      this.allReset();
      this._router.navigate(['/']);
    }
  }

  /* 
    HANDLE ORDER WITH LOCAL.
  */

  saveDataInfoLocal() {
    if (this.isOrderConfirmed) return;

    if (this.form?.get('pickupLocationAddress')?.value) {
      const pendingOrderData = {
        formData: this.form?.value,
        docIdFire: this.docIdFire || null,
        selectedHandling: this.selectedHandling || null,
        handlingItem: this.handlingItem || null,
        attachmentUploadedUrl: this.attachmentUploadedUrl || null,
        isAttachmentUploaded: this.isAttachmentUploaded || false,
        selectedDeliveryMethod: this.selectedDeliveryMethod || null,
        selectedPaymentMethod: this.selectedPaymentMethod || null,
        cashSerive: this.selectedCashService ? this.selectedCashService : null,
        isHeavyItemAndRelocateOrder: this.isHeavyItemAndRelocateOrder,
        selectedPackageSize: this.selectedPackageSize,
        isSaverPlanBottomSheetShow: this.isSaverPlanBottomSheetShow,
      };
      if (this.isHeavyItemAndRelocateOrder) {
        localStorage.setItem(
          'PENDINGHEAVYORDERDATA',
          JSON.stringify(pendingOrderData)
        );
      } else {
        localStorage.setItem(
          'PENDINGORDERDATA',
          JSON.stringify(pendingOrderData)
        );
      }
    }
  }

  getQueryParams() {
    // failback case if payment failed or declined
    if (this.isHeavyItemAndRelocateOrder) {
      const heavyOrderData = localStorage.getItem('PENDINGHEAVYORDERDATA');
      if (heavyOrderData) {
        try {
          this.pendingOrderData = JSON.parse(heavyOrderData);
          this.fillOrderDataByLocalData();
        } catch (error) {
          console.error('Error parsing PENDINGHEAVYORDERDATA:', error);
          localStorage.removeItem('PENDINGHEAVYORDERDATA');
        }
      }
      // Firebase document will be initialized when pickup location is selected
    } else {
      const orderData = localStorage.getItem('PENDINGORDERDATA');
      if (orderData) {
        try {
          this.pendingOrderData = JSON.parse(orderData);
          this.fillOrderDataByLocalData();
        } catch (error) {
          console.error('Error parsing PENDINGORDERDATA:', error);
          localStorage.removeItem('PENDINGORDERDATA');
        }
      }
      // Firebase document will be initialized when pickup location is selected
    }
  }

  fillOrderDataByLocalData() {
    this.isRestoringFromLocal = true;
    this.form?.disable();
    this.isDataLoading = true;
    this.docIdFire = this.pendingOrderData?.docIdFire;

    // Restore dropoffLocations FormArray first
    const savedDropoffs =
      this.pendingOrderData?.formData?.dropoffLocations || [];
    this.restoreDropoffLocations(savedDropoffs);

    // Now reset the rest of the form (excluding dropoffLocations)
    const { dropoffLocations, ...restFormData } =
      this.pendingOrderData?.formData || {};
    this.form?.patchValue(restFormData);

    this.reSubscribeOrder();
    this.form?.markAllAsTouched();

    // Restore other state as before...
    if (this.pendingOrderData?.selectedHandling) {
      this.setHandlingItemSelected(this.pendingOrderData.selectedHandling);
    }
    if (this.pendingOrderData?.handlingItem) {
      this.setPopularSelected(this.pendingOrderData.handlingItem);
    }
    if (this.pendingOrderData?.formData?.attachmentInfo)
      this.form
        ?.get('attachmentInfo')
        ?.setValue(this.pendingOrderData?.formData?.attachmentInfo);

    if (
      this.pendingOrderData?.attachmentUploadedUrl &&
      this.pendingOrderData?.isAttachmentUploaded
    ) {
      this.isAttachmentUploaded = true;
      this.attachmentUploadedUrl = this.pendingOrderData?.attachmentUploadedUrl;
    }
    if (
      this.pendingOrderData?.selectedPackageSize &&
      this.pendingOrderData?.isHeavyItemAndRelocateOrder
    ) {
      this.packageSizes.map((item) => {
        if (item.id == this.pendingOrderData?.selectedPackageSize.id)
          item.isSelected = 1;
      });
      this.selectedPackageSize = this.pendingOrderData?.selectedPackageSize;
    }

    // FIX: Ensure delivery methods are filtered and selected
    this.filterDeliveryMethodByCountry();
    this.filteredDeliveryMethods = [...this.deliveryMethods];
    this.selectedDeliveryMethod =
      this.pendingOrderData?.selectedDeliveryMethod || null;

    // Mark the restored selectedDeliveryMethod as selected in filteredDeliveryMethods
    if (this.selectedDeliveryMethod) {
      this.filteredDeliveryMethods.forEach((item) => {
        if (item.id === this.selectedDeliveryMethod.id) {
          item.isSelected = 1;
          this.selectedDeliveryMethod = item; // Update with the object from filteredDeliveryMethods
        } else {
          item.isSelected = 0;
        }
      });
    }

    // Update dropPointsToShow when selectedDeliveryMethod is restored
    if (this.selectedDeliveryMethod?.dropPoint) {
      this.dropPointsToShow = this.selectedDeliveryMethod.dropPoint;
    } else {
      this.dropPointsToShow = [];
    }

    this.form?.enable();
    this.subscribeDoc();

    // Update pickup address in Firebase if it was restored from localStorage
    if (this.docIdFire) {
      this.updatePickupAddressInFirebase();
    }
  }

  reSubscribeOrder() {
    this.updateOrderDoc()
      .pipe(take(1))
      .subscribe((updatedDoc: any) => {
        if (updatedDoc) {
          this.orderDoc = updatedDoc;
          // ...other code...
          // set dropoff address
          if (
            updatedDoc?.selectedAddress?.to?.length &&
            !this.isRestoringFromLocal
          )
            this.setDropAddress(updatedDoc.selectedAddress.to);
          // ...other code...
        }
        this.isDataLoading = false;
        this.isRestoringFromLocal = false; // reset after restore
      });
  }

  gettingErrorResetTheOrder() {
    if (this.isHeavyItemAndRelocateOrder) {
      if (localStorage.getItem('PENDINGHEAVYORDERDATA')) {
        localStorage.removeItem('PENDINGHEAVYORDERDATA');
        window.location.reload();
      }
    } else {
      if (localStorage.getItem('PENDINGORDERDATA')) {
        localStorage.removeItem('PENDINGORDERDATA');
        window.location.reload();
      }
    }
  }

  // set pickup address in fallback case.
  setPickupAddress(result) {
    this.form?.get('pickupLocation')?.setValue(result);
    this.form?.get('pickupLocationAddress')?.setValue(result.address);
  }

  // set drop address in fallbase case.
  setDropAddress(dropAddresses: Array<string>[]) {
    // UPDATE IN FORM
    dropAddresses.forEach((result: any, index) => {
      if (index) {
        this.addDropRow(index, false);
        this.dropoffLocations?.controls?.[index]
          ?.get('dropoffPointAddress')
          ?.setValue(result.address);
        this.dropoffLocations?.controls?.[index]
          ?.get('dropoffPoint')
          ?.setValue(result);
      } else {
        this.dropoffLocations?.controls?.[index]
          ?.get('dropoffPointAddress')
          ?.setValue(result.address);
        this.dropoffLocations?.controls?.[index]
          ?.get('dropoffPoint')
          ?.setValue(result);
      }
    });
  }

  // set handling item as selected in order fallback case.
  setHandlingItemSelected(selectedItem) {
    // set selected checked
    this.handlingMethods.map((item) => {
      if (item.id === selectedItem.id) {
        item.isSelected = 1;
      } else {
        // item.isSelected = 0
      }
    });

    this.selectedHandling = selectedItem;

    // "Packaged"
    if (this.selectedHandling?.id == 1) {
      this.handlingData = this.addNewKey(this.handlingAllData.package);
      this.resetSelectedDeliveryMethod();
      this.handlingItem = null;
    }
    // "care"
    else if (this.selectedHandling?.id == 2) {
      this.handlingData = this.addNewKey(this.handlingAllData.care);
      this.resetSelectedDeliveryMethod();
      this.handlingItem = null;
    }
    // "heavy"
    else if (this.selectedHandling?.id == 3) {
      this.handlingData = this.addNewKey(this.handlingAllData.heavy);
      this.resetSelectedDeliveryMethod();
      this.handlingItem = null;
    }
    // "relocation"
    else if (this.selectedHandling?.id == 4) {
      this.handlingData = this.addNewKey(this.handlingAllData.relocation);
      this.resetSelectedDeliveryMethod();
      this.handlingItem = null;
    }

    // FIX: Initialize filtered delivery methods after handling method selection
    this.initializeFilteredDeliveryMethods();

    this.saveDataInfoLocal();
  }

  // selection of popular send item in order fallback case.
  setPopularSelected(selectedItem) {
    this.handlingData.map((item) => {
      if (item.id === selectedItem.id) {
        item.isSelected = 1;
      }
    });
    this.handlingItem = selectedItem;
    if (
      this.form?.get('attachment')?.value ||
      this.form?.get('attachmentInfo')?.value
    )
      this.resetAttachment();

    // FIX: Initialize filtered delivery methods after handling method selection
    this.initializeFilteredDeliveryMethods();
    this.resetSelectedDeliveryMethod();
    this.selectedDeliveryMethod = null;
    this.dropPointsToShow = [];
  }

  /* 
    ON COMPONENT DESTROY.
  */
  ngOnDestroy(): void {
    console.log('ngOnDestroy');

    // Execute any pending Firebase updates before destruction
    if (this.firebaseUpdateTimeout) {
      clearTimeout(this.firebaseUpdateTimeout);
      this.executeFirebaseUpdate();
    }

    this.saveDataInfoLocal();
    this.unsubscribeFromDocument();

    if (!this.form?.get('pickupLocation')?.value) {
      this.afs
        .collection(OrderPool)
        .doc(this.docIdFire)
        .valueChanges()
        .subscribe()
        .unsubscribe();
      this.deleteDocument();
    }
    this.packageSizes = null;
    this.selectedPackageSize = null;
    this.selectedPackageSize = null;

    this.headings = null;

    this.handlingMethods = [];
    this.deliveryMethods = [];
    this.paymentMethods = [];
    this.cashSerive = [];

    this.handlingData = [];
    this.handlingItem = null;

    this.currentTime = null;

    this.form?.reset();
    this.groupIndex = null;
    this.handlingAllData = null;

    this.selectedDeliveryMethod = null;
    this.dropPointsToShow = [];
    this.selectedPaymentMethod = null;

    this.promoCodeList = [];
    this.appliedPromo = [];
    // deliveryCharges:[] = [];
    // selectedDeliveryChanges;
    this.orderDoc = null;
    this.isConfirmingOrder = false;
    this.isAttachmentUploaded = false;
    this.attachmentUploadedUrl = '';
    this.isDataLoading = false;
    this.isHeavyItemAndRelocateOrder = false;
    this.filteredDeliveryMethods = [];
    this.selectedHandling = null;
    this.docIdFire = null;
    console.error = function () { };
  }

  resetOrderFlow() {
    this.hardReload = true;
    const dialog = this._matDialog.open(ConfirmationDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '480px',
      data: {
        heading: 'Alert!',
        headingColor: 'text-red',
        message:
          'Proceeding with this action will reset your current order data, and this action cannot be undone. Are you sure you want to proceed?',
        action: {
          ok: 'Continue',
          cancel: 'Cancel',
          align: 'left',
        },
      },
    });

    dialog.afterClosed().subscribe((res) => {
      if (res) {
        if (this.isHeavyItemAndRelocateOrder) {
          if (localStorage.getItem('PENDINGHEAVYORDERDATA')) {
            localStorage.removeItem('PENDINGHEAVYORDERDATA');
            window.location.replace(window.location.href);
          }
        } else {
          if (localStorage.getItem('PENDINGORDERDATA')) {
            localStorage.removeItem('PENDINGORDERDATA');
            window.location.replace(window.location.href);
          }
        }
      } else {
        this.hardReload = false;
      }
    });
  }

  // Helper to restore dropoffLocations FormArray
  private restoreDropoffLocations(savedDropoffs: any[]) {
    const dropoffArray = this.form?.get('dropoffLocations') as FormArray;
    // Clear existing controls
    while (dropoffArray.length !== 0) {
      dropoffArray.removeAt(0);
    }
    // Add controls for each saved dropoff
    savedDropoffs.forEach((drop) => {
      dropoffArray.push(
        this._fb.group({
          dropoffPointAddress: [drop.dropoffPointAddress, Validators.required],
          dropoffPoint: [drop.dropoffPoint, Validators.required],
          packageSize: [
            drop.packageSize,
            this.isHeavyItemAndRelocateOrder ? Validators.required : null,
          ],
        })
      );
    });
  }

  public openPickupDrawer(): void {
    this.isPickupDrawerOpen = true;
    this.pickupDrawer.open();
  }

  // Handle the location selected event from the drawer component
  public onPickupLocationSelected(location: any): void {
    console.log('location in standard order', location);

    if (!location) {
      return;
    }

    if (this.drawerContext.type === 'pickup') {
      // Initialize Firebase document when pickup location is actually selected
      this.ensureFirebaseDocumentInitialized();

      this.form?.get('pickupLocation')?.setValue(location);
      this.form?.get('pickupLocationAddress')?.setValue(location.address);

      // Set delivery charge loading state when pickup location is selected
      this.isDeliveryChargeLoading = true;

      // Now update the pickup address in Firebase
      const params = {
        'selectedAddress.from': [location],
        changeStatus: 1,
      };
      this.updateDocWithParams(params);
    } else if (this.drawerContext.type === 'dropoff') {
      const idx = this.drawerContext.dropoffIndex;

      if (idx !== undefined && this.dropoffLocations?.controls?.[idx]) {
        // Remove the problematic line that sets global groupIndex
        // this.groupIndex = idx; // This line is causing the issue

        this.dropoffLocations?.controls?.[idx]
          ?.get('dropoffPointAddress')
          ?.setValue(location.address);
        this.dropoffLocations?.controls?.[idx]
          ?.get('dropoffPoint')
          ?.setValue(location);

        // Mark the form as touched to trigger validation
        this.dropoffLocations?.controls?.[idx]?.markAsTouched();

        // Update Firebase when dropoff location is selected
        this.updateDropOff();
      }
    }
    this.activeDropoffIndex = -1; // Reset active index after selection
    this.pickupDrawer.close();
  }

  public onPickupDrawerClose(): void {
    this.isPickupDrawerOpen = false;
    this.activeDropoffIndex = -1;
    this.pickupDrawer.close();
  }

  updatedeliveryMethods(deliveryCharges) {
    this.filteredDeliveryMethods.forEach((methods) => {
      deliveryCharges.forEach((ele) => {
        if (methods.id === ele.id) {
          methods.currency = ele.currency;
          methods.canUsePdasWalletAmount = ele.canUsePdasWalletAmount;
          methods.canUseWallet = ele.canUseWallet;
          methods.cashBack = ele.cashBack;
          methods.convenienceFee = ele.convenienceFee;
          methods.damageCoverAmount = ele.damageCoverAmount;
          methods.discountAmount = ele.discountAmount;
          methods.discountinpercentage = ele.discountinpercentage;
          methods.distance = ele.distance;
          methods.estimateTime = ele.estimateTime;
          methods.grossTotal = ele.grossTotal;
          methods.isPdasCommisionApplied = ele.isPdasCommisionApplied;
          methods.isRecommended = ele.isRecommended;
          methods.loadingFee = ele.loadingFee;
          methods.netTotal = ele.netTotal;
          methods.pdasCommisionPercentage = ele.pdasCommisionPercentage;
          methods.pdasWalletAmount = ele.pdasWalletAmount;
          methods.totalCharges = ele.totalCharges;
          methods.type = ele.type;
          methods.walletAmt = ele.walletAmt;
          methods.walletPercentage = ele.walletPercentage;
        }
      });
    });
  }

  get deliveryMessage(): string {
    const methodId = this.selectedDeliveryMethod?.id;
    // console.log('deliveryMessage', this.filteredDeliveryMethods?.filter(item => item.id === methodId)[0]);
    return this.filteredDeliveryMethods?.filter(item => item.id === methodId)[0]?.desc;

  }

  get saverMessage(): string {
    const methodId = this.selectedDeliveryMethod?.id;
    return this.filteredDeliveryMethods?.filter(item => item.id === methodId)[0]?.type + ' ' + this.filteredDeliveryMethods?.filter(item => item.id === methodId)[0]?.label + ' - ' + this.filteredDeliveryMethods?.filter(item => item.id === methodId)[0]?.saverDesc;
  }

  // Update dropoffLocations controls with new delivery charges
  private updateDropoffLocationsWithDeliveryCharges(
    deliveryCharges: any[]
  ): void {
    if (!deliveryCharges || !deliveryCharges.length) return;

    // Get the selected delivery method charges
    const selectedMethodCharges = this.selectedDeliveryMethod
      ? deliveryCharges.find(
        (item) => item.id === this.selectedDeliveryMethod.id
      )
      : null;

    if (selectedMethodCharges) {
      // Update each dropoff location with the new delivery charges
      this.dropoffLocations.controls.forEach((control, index) => {
        const currentValue = control.value;
        const currentDropoffPoint = currentValue.dropoffPoint || {};

        // Update the dropoffPoint with new deliveryCharge
        // Check if the selectedMethodCharges has dropPoint array with charges
        if (
          selectedMethodCharges.dropPoint &&
          selectedMethodCharges.dropPoint.length > 0
        ) {
          // Find matching dropPoint by address
          const matchingDropPoint = selectedMethodCharges.dropPoint.find(
            (dp: any) => dp.address === currentDropoffPoint.address
          );

          if (matchingDropPoint) {
            control.patchValue({
              ...currentValue,
              dropoffPoint: {
                ...currentDropoffPoint,
                deliveryCharge: matchingDropPoint.charges || 0,
              },
            });
          }
        } else {
          // Fallback: use the method's total charges if no dropPoint array
          control.patchValue({
            ...currentValue,
            dropoffPoint: {
              ...currentDropoffPoint,
              deliveryCharge:
                selectedMethodCharges.totalCharges ||
                selectedMethodCharges.netTotal ||
                0,
            },
          });
        }
      });
    }
  }

  private sanitizeDropoffsForUpdate(dropoffs: any[]): any[] {
    // Remove UI-only fields (like deliveryCharge) but preserve server-managed flags.
    const omitKeys = new Set(['deliveryCharge']);
    const existing = Array.isArray(this.orderDoc?.selectedAddress?.to)
      ? this.orderDoc.selectedAddress.to
      : [];
    return (dropoffs || []).map((dp) => {
      if (!dp || typeof dp !== 'object') return dp;
      const clean: any = {};
      Object.keys(dp).forEach((k) => {
        if (!omitKeys.has(k)) clean[k] = dp[k];
      });
      // Preserve isPhlenuTrustCheckApplied from existing doc when available
      const match = existing.find((e: any) => {
        if (!e) return false;
        if (e.locationId && dp.locationId)
          return e.locationId === dp.locationId;
        return e.address && dp.address && e.address === dp.address;
      });
      if (
        match &&
        typeof match.isPhlenuTrustCheckApplied !== 'undefined' &&
        typeof clean.isPhlenuTrustCheckApplied === 'undefined'
      ) {
        clean.isPhlenuTrustCheckApplied = match.isPhlenuTrustCheckApplied;
      }
      return clean;
    });
  }

  // Method to get all dropoff locations for the dialog
  public getAllDropoffLocations(): any[] {
    const allDropoffs = [];
    this.dropoffLocations?.controls?.forEach((control) => {
      const dropoffPoint = control?.get('dropoffPoint')?.value;
      if (dropoffPoint && dropoffPoint.locationId) {
        allDropoffs.push({
          dropoffPoint: dropoffPoint,
          dropoffPointAddress: control?.get('dropoffPointAddress')?.value,
        });
      }
    });
    return allDropoffs;
  }

  // Helper method to validate if pickup location is selected
  private isPickupLocationSelected(): boolean {
    return !!(
      this.form?.get('pickupLocationAddress')?.value &&
      this.form?.get('pickupLocation')?.value
    );
  }

  // Helper method to validate if dropoff location is selected for a specific index
  private isDropoffLocationSelected(index: number): boolean {
    if (index >= 0 && index < this.dropoffLocations?.controls?.length) {
      const control = this.dropoffLocations?.controls?.[index];
      return !!(
        control?.get('dropoffPointAddress')?.value &&
        control?.get('dropoffPoint')?.value
      );
    }
    return false;
  }

  // Method to handle location validation before opening drawer
  private validateLocationSelection(
    type: 'pickup' | 'dropoff',
    index?: number
  ): boolean {
    // Only validate pickup location requirement for dropoff if user is actively trying to select dropoff
    // Don't show error on first page load
    if (type === 'dropoff' && !this.isPickupLocationSelected()) {
      // Only show error if user has interacted with the form (i.e., tried to select a dropoff location)
      // Check if this is a user-initiated action, not just page load
      if (
        this.form?.get('pickupLocationAddress')?.dirty ||
        this.form?.get('pickupLocationAddress')?.touched
      ) {
        this.showSelectionError('pickupLocationAddress');
        return false;
      }
    }
    return true;
  }

  getIsTrustCheckApplied(): boolean {
    return !!this.orderDoc?.deliveryCharges?.[0]
      ?.totalPhlenuTrustCheckCommisionApplied;
  }

  get trustCheckTooltip(): string {
    const dropPoints = this.orderDoc?.deliveryCharges[0]?.dropPoint || [];

    const toTitleCase = (str: string) =>
      str.replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
      );

    const tooltipLines = dropPoints
      .filter((dp) => dp.isPhlenuTrustCheckApplied)
      .map((dp) => `${toTitleCase(dp.name)}: ${dp.phlenuTrustCheckCommision}`);

    return tooltipLines.join('\n');
  }

  // Helper methods to check if amounts are zero for shimmer display
  isAmountZero(amount: number | undefined | null): boolean {
    return amount === 0 || amount === null || amount === undefined;
  }

  // Check if specific data is loaded and available
  isDataLoaded(data: any): boolean {
    return data !== null && data !== undefined;
  }

  // Check if delivery method data is loaded
  isDeliveryMethodLoaded(): boolean {
    return this.isDataLoaded(this.selectedDeliveryMethod);
  }

  // Check if order document data is loaded
  isOrderDocLoaded(): boolean {
    return this.isDataLoaded(this.orderDoc);
  }

  // Check if drop points data is loaded
  isDropPointsLoaded(): boolean {
    return (
      this.isDataLoaded(this.dropPointsToShow) &&
      this.dropPointsToShow.length > 0
    );
  }

  // Check if specific amount data is loaded
  isAmountLoaded(amount: number | undefined | null): boolean {
    // Amount is loaded if it's not undefined/null, regardless of whether it's zero
    return amount !== null && amount !== undefined;
  }

  // Show shimmer for specific amount if data is not loaded or delivery charge is loading
  shouldShowAmountShimmer(amount: number | undefined | null): boolean {
    return !this.isAmountLoaded(amount) || this.isDeliveryChargeLoading;
  }

  // Show shimmer for delivery method data
  shouldShowDeliveryMethodShimmer(): boolean {
    return !this.isDeliveryMethodLoaded() || this.isDeliveryChargeLoading;
  }

  // Show shimmer for order document data
  shouldShowOrderDocShimmer(): boolean {
    return !this.isOrderDocLoaded() || this.isDataLoading;
  }

  // Show shimmer for drop points data
  shouldShowDropPointsShimmer(): boolean {
    // Show shimmer if:
    // 1. Data is loading, OR
    // 2. Delivery charge is loading, OR
    // 3. No delivery method is selected yet, OR
    // 4. Delivery method is selected but no drop points are available yet
    return (
      this.isDataLoading ||
      this.isDeliveryChargeLoading ||
      !this.selectedDeliveryMethod ||
      (this.selectedDeliveryMethod &&
        (!this.dropPointsToShow || this.dropPointsToShow.length === 0))
    );
  }

  // Show shimmer for payment summary section
  shouldShowPaymentSummaryShimmer(): boolean {
    return (
      this.shouldShowDeliveryMethodShimmer() ||
      this.shouldShowOrderDocShimmer() ||
      this.shouldShowDropPointsShimmer()
    );
  }

  // Get amount display with proper handling
  getAmountDisplay(amount: number | undefined | null): string {
    // If amount is null/undefined, return '0'
    if (amount === null || amount === undefined) {
      return '0';
    }
    // If amount is zero, return '0'
    if (amount === 0) {
      return '0';
    }
    // Otherwise return the amount as string
    return amount.toString();
  }
}
